"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7959],{

/***/ 6949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Block_Block; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var props_sizing = __webpack_require__(88270);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Block/Block.js








const Block = (param)=>/*#__PURE__*/ {
    let { utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , sizing ={
        ...props_sizing/* sizingProps */.H6
    } , className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), ...(0,props_sizing/* sizingClassName */.rs)(sizing), className),
        ...props
    });
};
Block.propTypes = {
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sizing: props_sizing/* sizingPropTypes */.bm,
    className: prop_types.string
};
/* harmony default export */ var Block_Block = (Block);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js



/***/ }),

/***/ 18774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Button/Button.js








const Button = (param)=>{
    let { Tag ="button" , type ="button" , styleType ="primary" , isTheme =false , isOutline =false , isOutline2 =false , isBlock =false , isPreLine =false , size , disabled =false , className , forwardRef , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    const tabType = Tag !== "a" && {
        type
    };
    const themeClassName = !isTheme ? [
        !isOutline && !isOutline2 && "btn-".concat(styleType),
        isOutline && "btn-outline-".concat(styleType),
        isOutline2 && "btn-outline2-".concat(styleType)
    ] : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        ...tabType,
        ref: forwardRef,
        className: (0,classes/* classes */.S)("btn", ...themeClassName, isBlock && "btn-block", isPreLine && "btn--pre-line", size && "btn-".concat(size), disabled && "disabled", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Button.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "a",
            "button"
        ]),
        prop_types.elementType
    ]),
    type: (0,prop_types.oneOf)([
        "button",
        "submit",
        "reset"
    ]),
    styleType: (0,prop_types.oneOf)([
        "primary",
        "secondary",
        "success",
        "danger",
        "warning",
        "info",
        "gray",
        "dark",
        "light",
        "info-light",
        "link",
        "copy",
        "input-group"
    ]),
    isTheme: prop_types.bool,
    isOutline: prop_types.bool,
    isOutline2: prop_types.bool,
    isBlock: prop_types.bool,
    isPreLine: prop_types.bool,
    disabled: prop_types.bool,
    size: (0,prop_types.oneOf)([
        "xs",
        "s",
        "m",
        "l"
    ]),
    className: prop_types.string,
    forwardRef: forward_ref/* default */.Z,
    focus: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
const ButtonLink = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
        Tag: "a",
        ...props
    });
Button.Link = ButtonLink;
/* harmony default export */ var Button_Button = ((0,pureFC/* default */.Z)(Button));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js



/***/ }),

/***/ 10980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ButtonTheme_ButtonTheme; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/ButtonTheme/ButtonTheme.js





const ButtonTheme = (param)=>/*#__PURE__*/ {
    let { className , styleType , ...props } = param;
    return (0,jsx_runtime.jsx)(Button/* default */.Z, {
        isTheme: true,
        className: (0,classes/* classes */.S)("button-theme-".concat(styleType), className),
        ...props
    });
};
ButtonTheme.propTypes = {
    styleType: (0,prop_types.oneOf)([
        "submit",
        "modal-submit",
        "modal-submit-active",
        "print-invoice",
        "place-order",
        "topbar"
    ]).isRequired,
    className: prop_types.string
};
const ButtonThemeLink = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTheme, {
        Tag: "a",
        ...props
    });
ButtonTheme.Link = ButtonThemeLink;
/* harmony default export */ var ButtonTheme_ButtonTheme = (ButtonTheme);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/ButtonTheme/index.js



/***/ }),

/***/ 36697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Inline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31987);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const DropdownMenu = (param)=>/*#__PURE__*/ {
    let { className ="" , shadow =true , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("dropdown-menu", !shadow && "no-shadow", className),
        ...props,
        children: children
    });
};
DropdownMenu.propTypes = {
    shadow: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    ..._Inline__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (DropdownMenu);


/***/ }),

/***/ 65446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js + 1 modules
var Inline = __webpack_require__(31987);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 2 modules
var Icon = __webpack_require__(19911);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Triangle.js







const DropdownTriangle = (param)=>{
    let { isOpen , isOpenColor , color , size , spacing  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
        className: "dropdown-title__triangle",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: isOpen ? "angle-up" : "angle-down",
            spacing: (0,pureProps/* deepMergeProps */.p)({
                m: 0
            }, (0,pureProps/* default */.Z)(spacing)),
            color: isOpen ? isOpenColor : color,
            size: size
        })
    });
};
const { name: Triangle_name , ...IconPropTypes } = Icon/* default.propTypes */.Z.propTypes;
DropdownTriangle.propTypes = {
    isOpen: prop_types.bool,
    isOpenColor: sx/* colorPropTypes */.AK,
    ...IconPropTypes
};
/* harmony default export */ var Triangle = (DropdownTriangle);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/handlers.js
var handlers = __webpack_require__(22953);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Title.js









const DropdownTitle = (param)=>{
    let { isOpen =false , triangle =true , className ="" , children , childrenProps , triangleProps ={} , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
        className: (0,classes/* classes */.S)("dropdown-title", isOpen && "dropdown-title--open", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inline/* default */.Z, {
            ...childrenProps,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
                    className: "dropdown-title__text",
                    children: children
                }),
                triangle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Triangle, {
                    isOpen: isOpen,
                    ...triangleProps
                }) : null
            ]
        })
    });
};
DropdownTitle.propTypes = {
    isOpen: prop_types.bool,
    triangle: prop_types.bool,
    ...Inline/* default.propTypes */.Z.propTypes,
    childrenProps: (0,prop_types.shape)({
        ...Inline/* default.propTypes */.Z.propTypes
    }),
    triangleProps: (0,prop_types.shape)({
        color: sx/* colorPropTypes */.AK,
        isOpenColor: sx/* colorPropTypes */.AK,
        spacing: spacing/* spacingPropTypes */.Xj
    })
};
const DropdownTitleLink = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownTitle, {
        Tag: "a",
        ...props,
        onClick: handlers/* prevent */.X$
    });
DropdownTitle.Link = DropdownTitleLink;
/* harmony default export */ var Title = (DropdownTitle);


/***/ }),

/***/ 38199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Dropdown_Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js + 1 modules
var Inline = __webpack_require__(31987);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/DropDownProvider/context.js
var context = __webpack_require__(17223);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Item.js







const DropdownItem = (param)=>{
    let { className ="" , isOpen , isMegaMenu , forwardRef , children , dropdown , ...props } = param;
    const { currentAction  } = (0,context/* useDropDown */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
        forwardRef: forwardRef,
        className: (0,classes/* classes */.S)("dropdown", isMegaMenu && "dropdown--mega-menu", currentAction && "dropdown-action--".concat(currentAction), isOpen && "dropdown--open", className),
        ...props,
        children: children
    });
};
DropdownItem.propTypes = {
    className: prop_types.string,
    isOpen: prop_types.bool,
    isMegaMenu: prop_types.bool,
    dropdown: (0,prop_types.shape)({
        action: (0,prop_types.oneOf)([
            "onClick",
            "onHover",
            "onCSS"
        ]),
        sm: (0,prop_types.shape)({
            action: (0,prop_types.oneOf)([
                "onClick",
                "onHover",
                "onCSS"
            ])
        }),
        md: (0,prop_types.shape)({
            action: (0,prop_types.oneOf)([
                "onClick",
                "onHover",
                "onCSS"
            ])
        }),
        lg: (0,prop_types.shape)({
            action: (0,prop_types.oneOf)([
                "onClick",
                "onHover",
                "onCSS"
            ])
        })
    }),
    forwardRef: forward_ref/* default */.Z,
    children: prop_types.node
};
/* harmony default export */ var Item = (DropdownItem);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Body.js
/* eslint-disable react/forbid-prop-types */ 






const DropdownBody = (param)=>{
    let { Tag ="span" , settings , isOpen =false , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , align ="left" , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("dropdown-body", align && "dropdown-body--align-".concat(align), isOpen && "dropdown-body--open", ...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)({
            bgColor: "white"
        }, (0,pureProps/* default */.Z)(utility))), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
DropdownBody.propTypes = {
    Tag: prop_types.string,
    isOpen: prop_types.bool,
    isPreRender: prop_types.bool,
    className: prop_types.string,
    settings: prop_types.object,
    align: (0,prop_types.oneOf)([
        "left",
        "right"
    ]),
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node
};
/* harmony default export */ var Body = (DropdownBody);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Title.js + 1 modules
var Title = __webpack_require__(65446);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fn.js
var fn = __webpack_require__(46393);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/click-outside.js

const isOutsideOf = (el)=>(param)=>{
        let { target  } = param;
        return !(el === target || el.contains(target));
    };
const onOutsideClick = (el, handler)=>{
    const documentClickHandler = (0,fn/* callIf */.bd)(isOutsideOf(el), handler);
    document.addEventListener("click", documentClickHandler);
    return ()=>document.removeEventListener("click", documentClickHandler);
};
/* harmony default export */ var click_outside = (onOutsideClick);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/DropDownProvider/index.js
/* eslint-disable react/forbid-prop-types */ 




function DropDownProvider(param) {
    let { settings , changeCurrentAction , initialAction , currentAction , initialState =false , children  } = param;
    const [isOpen, setState] = (0,react.useState)(initialState);
    const containerRef = (0,react.useRef)(null);
    const open = (0,react.useCallback)(()=>{
        setState(true);
    }, []);
    const close = (0,react.useCallback)(()=>{
        setState(false);
    }, []);
    const toggle = (0,react.useCallback)(()=>{
        setState((state)=>!state);
    }, [
        isOpen
    ]);
    (0,react.useEffect)(()=>{
        const { current  } = containerRef;
        return current != null ? click_outside(current, close) : undefined;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: {
            isOpen,
            changeCurrentAction,
            initialAction,
            currentAction,
            open,
            close,
            toggle,
            settings,
            containerRef
        },
        children: children
    });
}
DropDownProvider.propTypes = {
    settings: prop_types.object,
    initialAction: prop_types.string,
    currentAction: prop_types.string,
    changeCurrentAction: prop_types.func,
    initialState: prop_types.bool,
    children: prop_types.node
};
const DropDownConsumer = context/* default.Consumer */.Z.Consumer;
/* harmony default export */ var utils_DropDownProvider = (DropDownProvider);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/useWindowSize.js

const useWindowSize = ()=>{
    const [windowSize, setWindowSize] = (0,react.useState)({
        width: undefined,
        height: undefined
    });
    (0,react.useEffect)(()=>{
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};
/* harmony default export */ var utils_useWindowSize = (useWindowSize);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Dropdown.js










const dropdownProps = {
    action: null,
    sm: {
        action: null
    },
    md: {
        action: null
    },
    lg: {
        action: null
    }
};
const ON_CLICK = "onClick";
const ON_HOVER = "onHover";
const ON_CSS = "onCSS";
const Dropdown = (param)=>{
    let { dropdown ={
        ...dropdownProps
    } , className ="" , isMegaMenu =false , initialState , ...props } = param;
    const windowSize = utils_useWindowSize();
    const [currentAction, setCurrentAction] = (0,react.useState)(null);
    const pureDropdownProps = (0,pureProps/* deepMergeProps */.p)({
        action: ON_CLICK
    }, (0,pureProps/* default */.Z)(dropdown));
    const { action , sm , md , lg  } = pureDropdownProps;
    const getActionName = (0,react.useCallback)((device)=>{
        const deviceActionName = device && typeof device.action === "string" ? device.action : "";
        return typeof device === "string" ? device : deviceActionName;
    }, []);
    const width = (0,react.useMemo)(()=>+windowSize.width, [
        windowSize
    ]);
    const isAll = (0,react.useMemo)(()=>getActionName(action), [
        getActionName
    ]);
    const isSM = (0,react.useMemo)(()=>width < 640 && getActionName(sm), [
        width,
        getActionName
    ]);
    const isMD = (0,react.useMemo)(()=>width >= 640 && width < 1024 && getActionName(md), [
        width,
        getActionName
    ]);
    const isLG = (0,react.useMemo)(()=>width >= 1024 && getActionName(lg), [
        width,
        getActionName
    ]);
    const detectDevice = (0,react.useCallback)((actionName, param)=>{
        let { ...devices } = param;
        return devices.isAll === actionName && !devices.isSM && !devices.isMD && !devices.isLG || devices.isSM === actionName || devices.isMD === actionName || devices.isLG === actionName;
    }, []);
    const dataOnClick = (0,react.useMemo)(()=>({
            status: detectDevice(ON_CLICK, {
                isAll,
                isSM,
                isMD,
                isLG
            }),
            key: ON_CLICK
        }), [
        detectDevice,
        isAll,
        isSM,
        isMD,
        isLG
    ]);
    const dataOnHover = (0,react.useMemo)(()=>({
            status: detectDevice(ON_HOVER, {
                isAll,
                isSM,
                isMD,
                isLG
            }),
            key: ON_HOVER
        }), [
        detectDevice,
        isAll,
        isSM,
        isMD,
        isLG
    ]);
    const dataOnCSS = (0,react.useMemo)(()=>({
            status: detectDevice(ON_CSS, {
                isAll,
                isSM,
                isMD,
                isLG
            }),
            key: ON_CSS
        }), [
        detectDevice,
        isAll,
        isSM,
        isMD,
        isLG
    ]);
    const actionHandler = (0,react.useCallback)((fn)=>{
        let actionProps = {};
        if (dataOnHover.status) {
            actionProps = {
                onMouseEnter: fn,
                onMouseLeave: fn
            };
        }
        if (dataOnClick.status) {
            actionProps = {
                onClick: fn
            };
        }
        if (dataOnCSS.status) {
            actionProps = ()=>{};
        }
        return actionProps;
    }, [
        dataOnHover,
        dataOnClick,
        dataOnCSS
    ]);
    const initialAction = (0,react.useMemo)(()=>{
        let result;
        switch(true){
            case dataOnHover.status:
                result = dataOnHover.key;
                break;
            case dataOnCSS.status:
                result = dataOnCSS.key;
                break;
            case dataOnClick.status:
                result = dataOnClick.key;
                break;
            default:
                result = null;
                break;
        }
        return result;
    }, [
        dataOnHover,
        dataOnClick,
        dataOnCSS
    ]);
    const handleChangeCurrentAction = (0,react.useCallback)((value)=>setCurrentAction(value), [
        initialAction,
        currentAction,
        setCurrentAction
    ]);
    (0,react.useEffect)(()=>{
        setCurrentAction(initialAction);
    }, [
        setCurrentAction,
        initialAction
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_DropDownProvider, {
        initialAction: initialAction,
        currentAction: currentAction,
        changeCurrentAction: handleChangeCurrentAction,
        settings: pureDropdownProps,
        isMegaMenu: isMegaMenu,
        initialState: initialState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownConsumer, {
            children: (param)=>/*#__PURE__*/ {
                let { isOpen , toggle , containerRef  } = param;
                return (0,jsx_runtime.jsx)(Item, {
                    className: className,
                    isOpen: isOpen,
                    isMegaMenu: isMegaMenu,
                    forwardRef: containerRef,
                    dropdown: pureDropdownProps,
                    ...actionHandler(toggle),
                    ...props
                });
            }
        })
    });
};
Dropdown.propTypes = {
    ...Item.propTypes,
    className: prop_types.string,
    initialState: prop_types.bool
};
const Dropdown_Body = (props)=>{
    const { isOpen , settings  } = (0,context/* useDropDown */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
        settings: settings,
        isOpen: isOpen,
        ...props
    });
};
const Dropdown_Title = (props)=>{
    const { isOpen  } = (0,context/* useDropDown */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
        isOpen: isOpen,
        ...props
    });
};
Dropdown.Title = Dropdown_Title;
Dropdown.Body = Dropdown_Body;
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/index.js



/***/ }),

/***/ 38661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: true,
            px: true,
            children: children
        })
    });
};
FooterContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container.propTypes */ .W2.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterContainer);


/***/ }),

/***/ 7212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* binding */ FooterCopyrightLink; },
/* harmony export */   "rQ": function() { return /* binding */ FooterCopyrightText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25522);






const FooterCopyright = (param)=>/*#__PURE__*/ {
    let { className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("footer__copyright", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
            mx: true,
            py: true,
            sx: {
                textAlign: "center",
                lg: {
                    textAlign: "right"
                }
            },
            children: children
        })
    });
};
FooterCopyright.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterCopyrightText = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
        spacing: {
            pt: 0
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "footer__copyright_text",
            children: children
        })
    });
};
FooterCopyrightText.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterCopyrightLink = (param)=>{
    let { href , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isBaseClassName: false,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("footer__copyright_link", className),
        href: href,
        ...props,
        children: children
    });
};
FooterCopyrightLink.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const CompanyName = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "footer__copyright_company",
        children: children
    });
};
CompanyName.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
FooterCopyrightText.CompanyName = CompanyName;
/* harmony default export */ __webpack_exports__["ZP"] = (FooterCopyright);


/***/ }),

/***/ 33768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _LogoLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46096);





const FooterLogo = (param)=>/*#__PURE__*/ {
    let { logoPath , logoAlt ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LogoLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            imgSrc: logoPath,
            alt: logoAlt,
            ...props
        })
    });
};
FooterLogo.propTypes = {
    logoPath: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    logoAlt: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterLogo);


/***/ }),

/***/ 78682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterMainContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        lg: 9,
        ...props,
        children: children
    });
};
FooterMainContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterMainContainer);


/***/ }),

/***/ 53512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hr": function() { return /* binding */ FooterNavList; },
/* harmony export */   "Pw": function() { return /* binding */ FooterNavCol; },
/* harmony export */   "Q1": function() { return /* binding */ FooterNavListTitle; },
/* harmony export */   "iT": function() { return /* binding */ FooterNavListItem; },
/* harmony export */   "jO": function() { return /* binding */ FooterNavItemLink; },
/* harmony export */   "px": function() { return /* binding */ FooterNavTitleLink; },
/* harmony export */   "z4": function() { return /* binding */ FooterNavRow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6949);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67924);







const FooterNav = (param)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav", className),
        ...props
    });
};
FooterNav.propTypes = {
    ..._Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const FooterNavRow = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        py: true,
        ...props,
        children: children
    });
};
FooterNavRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavCol = (param)=>/*#__PURE__*/ {
    let { sm =6 , md ="shrink" , lg ="shrink" , className ="" , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        sm: sm,
        md: md,
        lg: lg,
        className: className,
        ...props,
        children: children
    });
};
FooterNavCol.propTypes = {
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavList = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav-list", className),
        children: children
    });
};
FooterNavList.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavListItem = (param)=>{
    let { enable =true , className ="" , children  } = param;
    return enable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav-list_item", className),
        children: children
    }) : null;
};
FooterNavListItem.propTypes = {
    enable: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavItemLink = (param)=>{
    let { children , className ="" , href ="/" , isBold =false , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav-list_item-link", isBold && "footer__nav-list_item-link--bold", className),
        ...props,
        children: children
    });
};
FooterNavItemLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    isBold: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
const FooterNavListTitle = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "footer__nav-list_title",
        ...props,
        children: children
    });
};
FooterNavListTitle.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavTitleLink = (param)=>{
    let { children , className ="" , href ="/" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav-list_title-link", className),
        ...props,
        children: children
    });
};
FooterNavTitleLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
/* harmony default export */ __webpack_exports__["ZP"] = (FooterNav);


/***/ }),

/***/ 58287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterSideBarContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        lg: 3,
        ...props,
        children: children
    });
};
FooterSideBarContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterSideBarContainer);


/***/ }),

/***/ 72025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FooterSocialItemLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19911);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67924);







const FooterSocial = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        spacing: {
            pt: 0
        },
        children: children
    });
};
FooterSocial.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterSocialItemLink = (param)=>{
    let { name , href , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__social_item-link", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            name: name
        })
    });
};
FooterSocialItemLink.propTypes = {
    name: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterSocial);


/***/ }),

/***/ 9458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Footer.js








const Footer = (param)=>{
    let { utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , isBorderNone =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: (0,classes/* classes */.S)("footer", ...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)(isBorderNone ? {
            border: {
                width: 0
            }
        } : {}, (0,pureProps/* default */.Z)(utility))), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        children: children
    });
};
Footer.propTypes = {
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    isBorderNone: prop_types.bool,
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/index.js



/***/ }),

/***/ 67478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ Col; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X2": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88270);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_forward_ref__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52418);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23720);










const Container = (param)=>{
    let { Tag ="div" , isFluid =false , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("grid-container", isFluid && "fluid", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), className),
        children: children
    });
};
Container.propTypes = {
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_8__.node.isRequired,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingPropTypes */ .Xj
};
const Row = (param)=>{
    let { forwardRef , Tag ="div" , position ="grid-x" , smCols , mdCols , lgCols , mx =false , px =false , my =false , py =false , center =false , middle =false , justify =false , bottom =false , start =false , spaceBetween =false , className ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , sizing ={
        ..._insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingProps */ .H6
    } , children , ...props } = param;
    // eslint-disable-next-line no-nested-ternary
    const alignItemsProps = start ? "start" : middle ? "center" : bottom ? "end" : null;
    // eslint-disable-next-line no-nested-ternary
    const justifyContentProps = center ? "center" : justify ? "between" : null;
    // eslint-disable-next-line no-nested-ternary
    const alignContentProps = spaceBetween ? "between" : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ref: forwardRef,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)(position, mx && "grid-margin-x", px && "grid-padding-x", my && "grid-margin-y", py && "grid-padding-y", smCols && "small-up-".concat(smCols), mdCols && "medium-up-".concat(mdCols), lgCols && "large-up-".concat(lgCols), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_9__/* .deepMergeProps */ .p)({
            align: {
                items: alignItemsProps,
                content: alignContentProps
            },
            justify: justifyContentProps
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), ...(0,_insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingClassName */ .rs)(sizing), className),
        ...props,
        children: children
    });
};
Row.propTypes = {
    forwardRef: _utils_forward_ref__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    position: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "grid-x",
        "grid-y"
    ]),
    mx: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    smCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    mdCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lgCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    middle: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    justify: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    bottom: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    spaceBetween: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_8__.node,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingPropTypes */ .Xj,
    sizing: _insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingPropTypes */ .bm,
    start: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool
};
const Col = (param)=>{
    let { Tag ="div" , forwardRef , auto =false , shrink =false , sm ="" , md ="" , lg ="" , smOffset , mdOffset , lgOffset , smOrder , mdOrder , lgOrder , className ="" , center =false , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , sizing ={
        ..._insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingProps */ .H6
    } , ...props } = param;
    const alignProp = center ? {
        justify: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ref: forwardRef,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("cell", auto && "auto", shrink && "shrink", sm && "small-".concat(sm), md && "medium-".concat(md), lg && "large-".concat(lg), smOffset && "small-offset-".concat(smOffset), mdOffset && "medium-offset-".concat(mdOffset), lgOffset && "large-offset-".concat(lgOffset), smOrder && "small-order-".concat(smOrder), mdOrder && "medium-order-".concat(mdOrder), lgOrder && "large-order-".concat(lgOrder), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_9__/* .deepMergeProps */ .p)({
            ...alignProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), ...(0,_insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingClassName */ .rs)(sizing), className),
        ...props,
        children: children
    });
};
Col.propTypes = {
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_8__.elementType,
    auto: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    shrink: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    center: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    smOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    mdOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lgOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    smOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    mdOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    lgOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_8__.node,
    sizing: _insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingPropTypes */ .bm,
    forwardRef: _utils_forward_ref__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
};


/***/ }),

/***/ 3197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const noop = ()=>{};
const context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    isOpen: false,
    onToggle: noop,
    onOpen: noop,
    onClose: noop
});
const useHeader = ()=>react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
/* harmony default export */ __webpack_exports__["Z"] = (context);


/***/ }),

/***/ 38529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Header_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Tag.js




const HeaderTag = (param)=>/*#__PURE__*/ {
    let { Tag ="header" , isHero =false , isBorderBottomNone , className ="" , children  } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("header", isHero && "header--hero", isBorderBottomNone && "header--border-none", className),
        role: "banner",
        children: children
    });
};
HeaderTag.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        prop_types.string,
        prop_types.elementType
    ]),
    isHero: prop_types.bool,
    isBorderBottomNone: prop_types.bool,
    children: prop_types.node.isRequired,
    className: prop_types.string
};
/* harmony default export */ var Tag = (HeaderTag);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Container.js




const HeaderContainer = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            px: true,
            className: "header__layout navbar",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    middle: true,
                    children: children
                })
            })
        })
    });
};
HeaderContainer.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var Container = (HeaderContainer);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/ToggleButton.js
/* eslint-disable jsx-a11y/control-has-associated-label */ 



const NavbarToggleButton = (param)=>/*#__PURE__*/ {
    let { classNames , isOpen =false , onClick  } = param;
    return (0,jsx_runtime.jsxs)("button", {
        onClick: onClick,
        type: "button",
        className: (0,classes/* classes */.S)("navbar__toggle", isOpen && "expanded", classNames),
        "data-toggle": "toggleButton",
        "data-target": "#navbar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            })
        ]
    });
};
NavbarToggleButton.propTypes = {
    classNames: prop_types.string,
    onClick: prop_types.func,
    isOpen: prop_types.bool
};
/* harmony default export */ var ToggleButton = (NavbarToggleButton);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/context.js
var context = __webpack_require__(3197);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Toggle.js







const HeaderToggle = (param)=>{
    let { children , withToggle =true  } = param;
    const { isOpen , onToggle  } = (0,context/* useHeader */.g)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        className: "navbar__header",
        lg: "shrink",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
            utility: {
                display: "flex",
                justify: "between",
                align: {
                    items: "center"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "header__logo",
                    children: children
                }),
                withToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton, {
                    onClick: onToggle,
                    isOpen: isOpen
                })
            ]
        })
    });
};
HeaderToggle.propTypes = {
    children: prop_types.node.isRequired,
    withToggle: prop_types.bool
};
/* harmony default export */ var Toggle = (HeaderToggle);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Collapse.js






const HeaderCollapse = (param)=>{
    let { children  } = param;
    const { isOpen  } = (0,context/* useHeader */.g)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        lg: "auto",
        className: (0,classes/* classes */.S)("navbar__collapse", isOpen && "show"),
        id: "navbar",
        children: children
    });
};
HeaderCollapse.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var Collapse = (HeaderCollapse);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Header.js








const Header = (param)=>{
    let { hero =false , isBorderBottomNone =false , className ="" , logo , children , withToggle  } = param;
    const [isOpen, setOpen] = (0,react.useState)(false);
    const onOpen = (0,react.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const onClose = (0,react.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const onToggle = (0,react.useCallback)(()=>{
        setOpen((state)=>!state);
    }, [
        setOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: {
            isOpen,
            onToggle,
            onOpen,
            onClose
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
            isHero: hero,
            isBorderBottomNone: isBorderBottomNone,
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                        withToggle: withToggle,
                        children: logo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse, {
                        children: children
                    })
                ]
            })
        })
    });
};
Header.propTypes = {
    hero: prop_types.bool,
    isBorderBottomNone: prop_types.bool,
    // inverted: bool,
    logo: prop_types.element.isRequired,
    children: prop_types.node,
    className: prop_types.string,
    withToggle: prop_types.bool
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js



/***/ }),

/***/ 42866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Heading_Heading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/Heading.js









const Heading = (param)=>{
    let { Tag ="h2" , size , color , weight , center , uppercase =false , className , italic , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    const isHeading = true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("heading", size && "heading-".concat(size), weight && fontWeight/* default */.Z[weight], center && "text-center", italic && "text-italic", uppercase && "text-uppercase", color && "text-color-".concat(color), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx, isHeading), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Heading.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6"
        ]),
        prop_types.elementType
    ]),
    size: props_sx/* fontSizePropTypes */.Gk,
    center: prop_types.bool,
    italic: prop_types.bool,
    uppercase: prop_types.bool,
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: props_sx/* colorPropTypes */.AK,
    className: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sx: props_sx/* sxPropTypes */.I1
};
/* harmony default export */ var Heading_Heading = ((0,pureFC/* default */.Z)(Heading));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js



/***/ }),

/***/ 19911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Icon_Icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/names.js
const iconNames = [
    "angle-down",
    "angle-left",
    "angle-right",
    "angle-up",
    "mac",
    "arrow-left",
    "arrow-right",
    "arrow-to-bottom",
    "check",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "clock",
    "copy",
    "debug",
    "long-arrow-left",
    "long-arrow-right",
    "play",
    "plus",
    "question-circle",
    "linux",
    "linux_rpm",
    "search",
    "shopping-cart",
    "sort",
    "times",
    "linux_deb",
    "user",
    "user-alt",
    "windows",
    "facebook-f",
    "twitter",
    "linkedin-in",
    "youtube",
    "facebook-square",
    "linkedin-square",
    "twitter-square",
    "youtube-alt",
    "dna",
    "book",
    "graduation-cap",
    "life-ring",
    "question",
    "question-circle-1",
    "video",
    "bullhorn",
    "file-star",
    "link-ext",
    "rocket-launch",
    "comments-alt",
    "instagram-square",
    "calendar-alt",
    "youtube-square"
];
/* harmony default export */ var names = (iconNames);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/Icon.js








const iconPrefix = "wrapper";
const legacyNames = new Map([
    [
        "download",
        "arrow-to-bottom"
    ],
    [
        "cart",
        "shopping-cart"
    ],
    [
        "profile",
        "user-alt"
    ],
    [
        "arrow-long-left",
        "long-arrow-left"
    ],
    [
        "arrow-long-right",
        "long-arrow-right"
    ],
    [
        "arrow-left-2",
        "arrow-left"
    ],
    [
        "arrow-right-2",
        "arrow-right"
    ]
]);
const Icon = (param)=>/*#__PURE__*/ {
    let { name , size , className , Tag ="i" , color , animate =false , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("".concat(iconPrefix, "-icon"), "".concat(iconPrefix, "-icon-").concat(legacyNames.get(name) || name), size && "".concat(iconPrefix, "-icon--").concat(size), animate && "".concat(iconPrefix, "-icon--animate"), color && "text-color-".concat(color), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Icon.propTypes = {
    name: (0,prop_types.oneOf)(names).isRequired,
    size: (0,prop_types.oneOf)([
        "xs",
        "s",
        "m",
        "l",
        "xl",
        "xxl",
        "xxxl",
        "xxxxl"
    ]),
    color: sx/* colorPropTypes */.AK,
    animate: prop_types.bool,
    className: prop_types.string,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    Tag: prop_types.elementType
};
/* harmony default export */ var Icon_Icon = ((0,pureFC/* default */.Z)(Icon));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js



/***/ }),

/***/ 10334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image_Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/AssetsProvider/index.js
var AssetsProvider = __webpack_require__(73445);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var props_sizing = __webpack_require__(88270);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Image/Image.js









const Image = (param)=>{
    let { isBaseUrl =true , forwardRef , src , alt ="" , shadow =false , grayscale =false , invert , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sizing ={
        ...props_sizing/* sizingProps */.H6
    } , className ="" , ...props } = param;
    const ctxBaseUrl = (0,react.useContext)(AssetsProvider/* default.context */.Z.context);
    const baseUrl = isBaseUrl ? ctxBaseUrl : "";
    const altText = alt.trim();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        ref: forwardRef,
        className: (0,classes/* classes */.S)("image", shadow && "image--shadow", grayscale && "image--grayscale", invert && "image--invert-".concat(invert), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), ...(0,props_sizing/* sizingClassName */.rs)(sizing), className),
        alt: altText,
        ...props,
        src: "".concat(baseUrl).concat(src)
    });
};
Image.propTypes = {
    forwardRef: forward_ref/* default */.Z,
    isBaseUrl: prop_types.bool,
    src: prop_types.string.isRequired,
    className: prop_types.string,
    alt: prop_types.string,
    shadow: prop_types.bool,
    grayscale: prop_types.bool,
    invert: (0,prop_types.oneOf)([
        "white",
        "black"
    ]),
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sizing: props_sizing/* sizingPropTypes */.bm
};
/* harmony default export */ var Image_Image = (Image);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js



/***/ }),

/***/ 31987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Inline_Inline; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/Inline.js








const Inline = (param)=>/*#__PURE__*/ {
    let { Tag ="span" , forwardRef , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        ref: forwardRef,
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Inline.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "span",
            "i",
            "em",
            "b",
            "strong"
        ]),
        prop_types.elementType
    ]),
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    className: prop_types.string,
    forwardRef: forward_ref/* default */.Z
};
/* harmony default export */ var Inline_Inline = (Inline);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js



/***/ }),

/***/ 71412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/Layout.js





const Header = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
Header.propTypes = {
    children: prop_types.node.isRequired
};
const Body = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
            role: "main",
            ...props
        })
    });
};
Body.propTypes = {
    ...Block/* default.propTypes */.Z.propTypes
};
const Footer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
Footer.propTypes = {
    children: prop_types.node.isRequired
};
const Layout = (param)=>/*#__PURE__*/ {
    let { bgColor ="transparent" , children , isWrapper =false , className =""  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "body{background-color: ".concat(bgColor, "}")
            }),
            !isWrapper && !className ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classes/* classes */.S)(isWrapper && "layout-wrapper", className),
                children: children
            })
        ]
    });
};
Layout.propTypes = {
    children: prop_types.node.isRequired,
    isWrapper: prop_types.bool,
    bgColor: prop_types.string,
    className: prop_types.string
};
Layout.Header = Header;
Layout.Body = Body;
Layout.Footer = Footer;
/* harmony default export */ var Layout_Layout = (Layout);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js



/***/ }),

/***/ 25522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Link/Link.js










const Link = (param)=>{
    let { Tag ="a" , isBaseClassName =true , external =false , size , weight , color , hoverColor , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className , ...props } = param;
    const sizeProps = size ? {
        fontSize: size
    } : {};
    const weightProps = weight ? {
        fontWeight: weight
    } : {};
    const defaultColorProps = color ? {
        fontColor: color
    } : {
        fontColor: null
    };
    const defaultColorHoverProps = hoverColor ? {
        fontColor: hoverColor
    } : {
        fontColor: null
    };
    const colorProps = {
        ...defaultColorProps,
        hover: {
            ...defaultColorHoverProps
        }
    };
    const classNameList = (0,react.useMemo)(()=>(0,classes/* classes */.S)(isBaseClassName && "link", external && "link--external", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)((0,pureProps/* deepMergeProps */.p)({
            ...sizeProps,
            ...weightProps,
            ...colorProps
        }, (0,pureProps/* default */.Z)(sx))), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className), [
        sizeProps,
        weightProps,
        colorProps
    ]);
    const classNameProp = classNameList ? {
        className: classNameList
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        ...props,
        ...classNameProp
    });
};
Link.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "a",
            "button"
        ]),
        prop_types.elementType
    ]),
    isBaseClassName: prop_types.bool,
    external: prop_types.bool,
    size: (0,prop_types.oneOf)([
        "xxxl",
        "xxl",
        "xl",
        "l",
        "m",
        "s",
        "xs"
    ]),
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: props_sx/* colorPropTypes */.AK,
    hoverColor: props_sx/* colorPropTypes */.AK,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    className: prop_types.string
};
const LinkButton = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
        Tag: "button",
        type: "button",
        ...props
    });
Link.Button = LinkButton;
/* harmony default export */ var Link_Link = ((0,pureFC/* default */.Z)(Link));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js



/***/ }),

/***/ 46096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LogoLink_LogoLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/LogoLink/LogoLink.js






const LogoLink = (param)=>/*#__PURE__*/ {
    let { href ="/" , external =true , imgSrc , alt ="" , className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: href,
        external: external,
        isBaseClassName: false,
        className: (0,classes/* classes */.S)("logo-link", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: imgSrc,
            className: (0,classes/* classes */.S)("logo"),
            alt: alt
        })
    });
};
LogoLink.propTypes = {
    href: prop_types.string,
    external: prop_types.bool,
    imgSrc: prop_types.string.isRequired,
    alt: prop_types.string,
    className: prop_types.string
};
/* harmony default export */ var LogoLink_LogoLink = (LogoLink);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/LogoLink/index.js



/***/ }),

/***/ 15062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ MegaMenuCol; }
/* harmony export */ });
/* unused harmony export MegaMenuRow */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const MegaMenuCol = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        sm: 12,
        md: 6,
        ...props
    });
};
const MegaMenuRow = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return _jsx(Row, {
        ...props
    });
};


/***/ }),

/***/ 4991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export ItemImage */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6949);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25522);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74229);
/* harmony import */ var _Navbar_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81453);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18981);
/* harmony import */ var _props_sizing__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88270);













const ItemLink = (param)=>{
    let { spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_8__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Navbar_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            spacing: (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_11__/* .deepMergeProps */ .p)({
                pl: 1
            }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(spacing)),
            ...props
        })
    });
};
ItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_12__.func
};
const ItemDescription = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_8__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_11__/* .deepMergeProps */ .p)({
            fontColor: "black--46",
            fontSize: "s"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(sx)),
        spacing: (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_11__/* .deepMergeProps */ .p)({
            mt: 1,
            pl: 1
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(spacing)),
        ...props
    });
};
ItemDescription.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const ItemImage = (param)=>{
    let { utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_9__/* .utilityProps */ .Gm
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_8__/* .spacingProps */ .tF
    } , sizing ={
        ..._props_sizing__WEBPACK_IMPORTED_MODULE_10__/* .sizingProps */ .H6
    } , className ="" , src , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        utility: utility,
        spacing: (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_11__/* .deepMergeProps */ .p)({
            pl: 1
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(spacing)),
        sizing: sizing,
        src: src,
        className: className,
        ...props
    });
};
ItemImage.propTypes = {
    ..._Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const MegaMenuItem = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        spacing: {
            my: 4
        },
        ...props
    });
};
MegaMenuItem.Link = ItemLink;
MegaMenuItem.Description = ItemDescription;
MegaMenuItem.Image = ItemImage;
/* harmony default export */ __webpack_exports__["Z"] = (MegaMenuItem);


/***/ }),

/***/ 80178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19911);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10334);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74229);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23720);









const BlockIcon = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "topbar-block-link-icon",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "s",
            name: "link-ext",
            ...props
        })
    });
};
const BlockImage = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        ...props
    });
};
const BlockDescription = (param)=>/*#__PURE__*/ {
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxProps */ .ET
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sx: (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* .deepMergeProps */ .p)({
            fontColor: "white",
            fontSize: "xs"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(sx)),
        ...props,
        children: children
    });
};
BlockDescription.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const MegaMenuBlockLink = (param)=>{
    let { className , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("topbar-block-link", className),
        ...props,
        children: children
    });
};
MegaMenuBlockLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
MegaMenuBlockLink.Icon = BlockIcon;
MegaMenuBlockLink.Image = BlockImage;
MegaMenuBlockLink.Description = BlockDescription;
/* harmony default export */ __webpack_exports__["Z"] = (MegaMenuBlockLink);


/***/ }),

/***/ 40535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);






const MegaMenuTitle = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            fontColor: "black--60",
            fontSize: "s",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(sx)
        },
        spacing: {
            pl: 1,
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(spacing)
        },
        ...props
    });
};
MegaMenuTitle.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (MegaMenuTitle);


/***/ }),

/***/ 69514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MegaMenu_MegaMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/MegaMenu.js






const MegaMenu = (param)=>{
    let { utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            mx: true,
            my: true,
            utility: (0,pureProps/* deepMergeProps */.p)({
                justify: "center"
            }, (0,pureProps/* default */.Z)(utility)),
            spacing: (0,pureProps/* deepMergeProps */.p)({
                py: 3
            }, (0,pureProps/* default */.Z)(spacing)),
            ...props,
            children: children
        })
    });
};
MegaMenu.propTypes = {
    ...Grid/* Row.propTypes */.X2.propTypes
};
/* harmony default export */ var MegaMenu_MegaMenu = (MegaMenu);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/index.js



/***/ }),

/***/ 88881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_forward_ref__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52418);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const NavbarItem = (param)=>{
    let { Tag ="li" , forwardRef , itemIcon , enable =true , secondary =false , className , ...props } = param;
    return enable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ref: forwardRef,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)(secondary && "secondary-nav__item", secondary && itemIcon && "secondary-nav__item-".concat(itemIcon), className),
        ...props
    }) : null;
};
NavbarItem.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOfType)([
        (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
            "li"
        ]),
        prop_types__WEBPACK_IMPORTED_MODULE_4__.elementType
    ]),
    itemIcon: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        "search"
    ]),
    enable: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    secondary: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    forwardRef: _utils_forward_ref__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarItem);


/***/ }),

/***/ 81453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _Header_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3197);
/* harmony import */ var _utils_DropDownProvider_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17223);







const NavbarItemLink = (param)=>{
    let { Tag =_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z , className , onClick =()=>{} , ...props } = param;
    const isLink = Tag === _Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    const config = isLink && {
        isBaseClassName: false
    };
    const { changeCurrentAction , initialAction , currentAction  } = (0,_utils_DropDownProvider_context__WEBPACK_IMPORTED_MODULE_5__/* .useDropDown */ .v)();
    const { onClose  } = (0,_Header_context__WEBPACK_IMPORTED_MODULE_4__/* .useHeader */ .g)();
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        if (isLink) {
            changeCurrentAction(null);
        }
        onClick(e);
        if (isLink) {
            onClose();
            setTimeout(()=>{
                changeCurrentAction(initialAction);
            }, 100);
        }
    }, [
        changeCurrentAction,
        initialAction,
        currentAction,
        isLink
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ...config,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("nav__item-link", className),
        onClick: handleClick,
        ...props
    });
};
NavbarItemLink.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_6__.elementType
    ]),
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_6__.func,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarItemLink);


/***/ }),

/***/ 37762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Navbar.js




const Navbar = (param)=>/*#__PURE__*/ {
    let { nav , type =null , className ="" , children , inverted  } = param;
    return (0,jsx_runtime.jsx)("ul", {
        className: (0,classes/* classes */.S)("nav", nav && "".concat(nav, "-nav"), type && "nav-type-".concat(type), inverted && "nav--inverted", className),
        children: children
    });
};
Navbar.propTypes = {
    nav: (0,prop_types.oneOf)([
        "primary",
        "secondary"
    ]).isRequired,
    type: (0,prop_types.oneOf)([
        1
    ]),
    className: prop_types.string,
    children: prop_types.node,
    inverted: prop_types.bool
};
/* harmony default export */ var Navbar_Navbar = (Navbar);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/index.js



/***/ }),

/***/ 1385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38199);
/* harmony import */ var _Dropdown_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36697);





const NavbarDropdownMenu = (param)=>{
    let { isList =true , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dropdown__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Body */ .Z.Body, {
        className: className,
        ...props,
        children: isList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dropdown_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: children
        }) : children
    });
};
NavbarDropdownMenu.propTypes = {
    isList: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarDropdownMenu);


/***/ }),

/***/ 36555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Navbar_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81453);
/* harmony import */ var _Dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38199);




const NavbarDropdownTitle = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Navbar_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: _Dropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Title */ .Z.Title,
        ...props,
        children: children
    });
};
NavbarDropdownTitle.propTypes = {
    ..._Dropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Title.propTypes */ .Z.Title.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarDropdownTitle);


/***/ }),

/***/ 86210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavbarDropdown_NavbarDropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/index.js + 6 modules
var Dropdown = __webpack_require__(38199);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Item.js
var Item = __webpack_require__(88881);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/NavbarDropdown.js






const DropdownUlItem = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
        Tag: "li",
        ...props
    });
};
const NavbarDropdown = (param)=>{
    let { isMegaMenu =false , isSecondaryNav =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
        Tag: DropdownUlItem,
        secondary: isSecondaryNav,
        isMegaMenu: isMegaMenu,
        className: (0,classes/* classes */.S)(className),
        children: children
    });
};
NavbarDropdown.propTypes = {
    isMegaMenu: prop_types.bool,
    isSecondaryNav: prop_types.bool,
    ...Dropdown/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var NavbarDropdown_NavbarDropdown = (NavbarDropdown);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/index.js



/***/ }),

/***/ 74229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Paragraph_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/Paragraph.js










const Paragraph = (param)=>{
    let { Tag ="p" , size , center , uppercase =false , color , className ="" , block =false , weight , italic , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    const fontSizeProp = size ? {
        fontSize: size
    } : {};
    const fontWeightProp = weight ? {
        fontWeight: weight
    } : {};
    const fontColorProp = color ? {
        fontColor: color
    } : {};
    const fontStyleProp = italic ? {
        fontStyle: "italic"
    } : {};
    const textAlignProp = center ? {
        textAlign: "center"
    } : {};
    const textTransformProp = uppercase ? {
        textTransform: "uppercase"
    } : {};
    const displayProp = block ? {
        display: "block"
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)({
            ...displayProp
        }, (0,pureProps/* default */.Z)(utility))), ...(0,props_sx/* sxClassName */.ZA)((0,pureProps/* deepMergeProps */.p)({
            ...fontWeightProp,
            ...fontSizeProp,
            ...fontColorProp,
            ...fontStyleProp,
            ...textAlignProp,
            ...textTransformProp
        }, (0,pureProps/* default */.Z)(sx))), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Paragraph.propTypes = {
    Tag: prop_types.string,
    size: props_sx/* fontSizePropTypes */.Gk,
    italic: prop_types.bool,
    center: prop_types.bool,
    block: prop_types.bool,
    uppercase: prop_types.bool,
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: props_sx/* colorPropTypes */.AK,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var Paragraph_Paragraph = ((0,pureFC/* default */.Z)(Paragraph));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js



/***/ }),

/***/ 93512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Section_Section; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Section/Section.js






const Section = (param)=>{
    let { className ="" , children , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
Section.propTypes = {
    className: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Section_Section = (Section);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js



/***/ }),

/***/ 43223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38199);
/* harmony import */ var _Dropdown_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65446);
/* harmony import */ var _Nav__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65717);





const Title = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Nav__WEBPACK_IMPORTED_MODULE_4__/* .TopBarNavItemInline */ .x1, {
        Tag: _Dropdown__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title,
        triangle: false,
        ...props,
        children: children
    });
};
Title.propTypes = {
    ..._Dropdown_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Link.propTypes */ .Z.Link.propTypes
};
const Body = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dropdown__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Body */ .Z.Body, {
        ...props
    });
};
Body.propTypes = {
    ..._Dropdown__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Body.propTypes */ .Z.Body.propTypes
};
const TopBarDropdown = (param)=>/*#__PURE__*/ {
    let { children , isMegaMenu =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Nav__WEBPACK_IMPORTED_MODULE_4__/* .TopBarNavItem */ .Bw, {
        Tag: _Dropdown__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        dropdown: {
            action: "onClick"
        },
        isMegaMenu: isMegaMenu,
        children: children
    });
};
TopBarDropdown.propTypes = {
    ..._Dropdown__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
TopBarDropdown.Title = Title;
TopBarDropdown.Body = Body;
/* harmony default export */ __webpack_exports__["Z"] = (TopBarDropdown);


/***/ }),

/***/ 39755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const TopBarLogo = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        shrink: true,
        spacing: {
            mr: 12,
            mt: 1
        },
        children: children
    });
};
TopBarLogo.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (TopBarLogo);


/***/ }),

/***/ 65717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ TopBarNavItem; },
/* harmony export */   "x1": function() { return /* binding */ TopBarNavItemInline; }
/* harmony export */ });
/* unused harmony export TopBarNavItemLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _insightfulscience_atomic_react_utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31987);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25522);







const TopBarNav = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        auto: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
            px: true,
            utility: {
                align: {
                    items: "center"
                }
            },
            children: children
        })
    });
};
TopBarNav.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const TopBarNavItem = (param)=>/*#__PURE__*/ {
    let { forwardRef , children , className ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        forwardRef: forwardRef,
        className: (0,_insightfulscience_atomic_react_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("topbar__nav-item", className),
        shrink: true,
        ...props,
        children: children
    });
};
TopBarNavItem.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col.propTypes */ .JX.propTypes
};
const TopBarNavItemLink = (param)=>{
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        isBaseClassName: false,
        className: (0,_insightfulscience_atomic_react_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("topbar__nav-item-link", className),
        ...props
    });
};
TopBarNavItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const TopBarNavItemInline = (param)=>{
    let { className ="" , isOpen , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,_insightfulscience_atomic_react_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("topbar__nav-item-inline", className),
        ...props
    });
};
TopBarNavItemInline.propTypes = {
    ..._insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_3__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["ZP"] = (TopBarNav);


/***/ }),

/***/ 88311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TopBar_TopBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/TopBar.js





const TopBar = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "topbar",
        utility: {
            sm: {
                display: "none"
            },
            md: {
                display: "none"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    align: {
                        items: "center"
                    }
                },
                children: children
            })
        })
    });
};
TopBar.propTypes = {
    children: prop_types.node
};
/* harmony default export */ var TopBar_TopBar = (TopBar);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/index.js



/***/ }),

/***/ 88270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H6": function() { return /* binding */ sizingProps; },
/* harmony export */   "bm": function() { return /* binding */ sizingPropTypes; },
/* harmony export */   "rs": function() { return /* binding */ sizingClassName; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

const additionalValues = [
    "auto",
    "full",
    "screen",
    "px"
];
const additionalMinValues = [
    "full",
    "screen"
];
const additionalMaxValues = [
    "full",
    "screen"
];
const values = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    91,
    92,
    93,
    94,
    95,
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164
];
const maskProps = {
    h: null,
    w: null,
    minH: null,
    minW: null,
    maxH: null,
    maxW: null
};
const maskPropTypes = {
    h: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalValues,
        ...values
    ]),
    w: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalValues,
        ...values
    ]),
    minH: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalMinValues,
        ...values
    ]),
    minW: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalMinValues,
        ...values
    ]),
    maxH: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalMaxValues,
        ...values
    ]),
    maxW: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalMaxValues,
        ...values
    ])
};
const sizingProps = {
    ...maskProps,
    sm: {
        ...maskProps
    },
    md: {
        ...maskProps
    },
    lg: {
        ...maskProps
    }
};
const sizingPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    ...maskPropTypes,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    }),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    }),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    })
});
const checkValue = (value)=>values.indexOf(value) !== -1;
const checkAdditionalValues = (value)=>additionalValues.indexOf(value) !== -1;
const checkAdditionalMinValues = (value)=>additionalMinValues.indexOf(value) !== -1;
const checkAdditionalMaxValues = (value)=>additionalMaxValues.indexOf(value) !== -1;
const responsiveCheckValues = function(h, w, minH, minW, maxH, maxW) {
    let media = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, mediaName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    if (media) {
        return [
            (checkValue(media.h) || checkAdditionalValues(media.h)) && "h-".concat(media.h, "--").concat(mediaName),
            (checkValue(media.w) || checkAdditionalValues(media.w)) && "w-".concat(media.w, "--").concat(mediaName),
            media.minH && (checkValue(media.minH) || checkAdditionalMinValues(media.minH)) && "min-h-".concat(media.minH, "--").concat(mediaName),
            media.minW && (checkValue(media.minW) || checkAdditionalMinValues(media.minW)) && "min-w-".concat(media.minW, "--").concat(mediaName),
            media.maxH && (checkValue(media.maxH) || checkAdditionalMaxValues(media.maxH)) && "max-h-".concat(media.maxH, "--").concat(mediaName),
            media.maxW && (checkValue(media.maxW) || checkAdditionalMaxValues(media.maxW)) && "max-w-".concat(media.maxW, "--").concat(mediaName)
        ];
    }
    return [
        (checkValue(w) || checkAdditionalValues(w)) && "w-".concat(w),
        (checkValue(h) || checkAdditionalValues(h)) && "h-".concat(h),
        (checkValue(minH) || checkAdditionalMinValues(minH)) && "min-h-".concat(minH),
        (checkValue(minW) || checkAdditionalMinValues(minW)) && "min-w-".concat(minW),
        (checkValue(maxH) || checkAdditionalMaxValues(maxH)) && "max-h-".concat(maxH),
        (checkValue(maxW) || checkAdditionalMaxValues(maxW)) && "max-w-".concat(maxW)
    ];
};
// TODO: can be expanded if needed (min-w / max-w / min-h / max-w)
const sizingClassName = (param)=>{
    let { h , w , minH , minW , maxH , maxW , sm , md , lg  } = param;
    const sizingClass = [
        ...responsiveCheckValues(h, w, minH, minW, maxH, maxW),
        ...responsiveCheckValues(h, w, minH, minW, maxH, maxW, sm, "sm"),
        ...responsiveCheckValues(h, w, minH, minW, maxH, maxW, md, "md"),
        ...responsiveCheckValues(h, w, minH, minW, maxH, maxW, lg, "lg")
    ];
    return sizingClass.filter(Boolean);
};


/***/ }),

/***/ 2349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RB": function() { return /* binding */ spacingClassName; },
/* harmony export */   "Xj": function() { return /* binding */ spacingPropTypes; },
/* harmony export */   "tF": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

const values = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    64,
    "auto",
    "m1",
    "m2",
    "m3",
    "m4",
    "m5",
    "m6",
    "m7",
    "m8",
    "m9",
    "m10",
    "m11",
    "m12",
    "m13",
    "m14",
    "m15",
    "m16",
    "m17",
    "m18",
    "m19",
    "m20",
    "m21",
    "m22",
    "m23",
    "m24",
    "m25",
    "m26",
    "m27",
    "m28",
    "m29",
    "m30",
    "m31",
    "m32",
    "m33",
    "m34",
    "m35",
    "m36",
    "m37",
    "m38",
    "m39",
    "m40",
    "m41",
    "m42",
    "m43",
    "m44",
    "m45",
    "m46",
    "m47",
    "m48",
    "m49",
    "m50",
    "m51",
    "m52",
    "m53",
    "m54",
    "m55",
    "m56",
    "m57",
    "m58",
    "m59",
    "m60",
    "m61",
    "m62",
    "m63",
    "m64"
];
const maskProps = {
    m: null,
    mr: null,
    ml: null,
    mt: null,
    mb: null,
    mx: null,
    my: null,
    p: null,
    pr: null,
    pl: null,
    pt: null,
    pb: null,
    px: null,
    py: null
};
const maskPropTypes = {
    m: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    mr: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    ml: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    mt: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    mb: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    mx: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    my: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    p: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    pr: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    pl: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    pt: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    pb: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    px: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    py: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values)
};
const spacingProps = {
    ...maskProps,
    sm: {
        ...maskProps
    },
    md: {
        ...maskProps
    },
    lg: {
        ...maskProps
    }
};
const spacingPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    ...maskPropTypes,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    }),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    }),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    })
});
const checkValue = (value)=>values.indexOf(value) !== -1;
const spacingClassName = (param)=>{
    let { ...props } = param;
    const { sm , md , lg , m , mr , ml , mt , mb , mx , my , p , pr , pl , pt , pb , px , py  } = props;
    // TODO: refactor to make code more concise
    return [
        checkValue(m) && "m-".concat(m),
        checkValue(mr) && "mr-".concat(mr),
        checkValue(ml) && "ml-".concat(ml),
        checkValue(mt) && "mt-".concat(mt),
        checkValue(mb) && "mb-".concat(mb),
        checkValue(mx) && "mx-".concat(mx),
        checkValue(my) && "my-".concat(my),
        checkValue(p) && "p-".concat(p),
        checkValue(pr) && "pr-".concat(pr),
        checkValue(pl) && "pl-".concat(pl),
        checkValue(pt) && "pt-".concat(pt),
        checkValue(pb) && "pb-".concat(pb),
        checkValue(px) && "px-".concat(px),
        checkValue(py) && "py-".concat(py),
        sm && checkValue(sm.m) && "m-".concat(sm.m, "--sm"),
        sm && checkValue(sm.mr) && "mr-".concat(sm.mr, "--sm"),
        sm && checkValue(sm.ml) && "ml-".concat(sm.ml, "--sm"),
        sm && checkValue(sm.mt) && "mt-".concat(sm.mt, "--sm"),
        sm && checkValue(sm.mb) && "mb-".concat(sm.mb, "--sm"),
        sm && checkValue(sm.mx) && "mx-".concat(sm.mx, "--sm"),
        sm && checkValue(sm.my) && "my-".concat(sm.my, "--sm"),
        sm && checkValue(sm.p) && "p-".concat(sm.p, "--sm"),
        sm && checkValue(sm.pr) && "pr-".concat(sm.pr, "--sm"),
        sm && checkValue(sm.pl) && "pl-".concat(sm.pl, "--sm"),
        sm && checkValue(sm.pt) && "pt-".concat(sm.pt, "--sm"),
        sm && checkValue(sm.pb) && "pb-".concat(sm.pb, "--sm"),
        sm && checkValue(sm.px) && "px-".concat(sm.px, "--sm"),
        sm && checkValue(sm.py) && "py-".concat(sm.py, "--sm"),
        md && checkValue(md.m) && "m-".concat(md.m, "--md"),
        md && checkValue(md.mr) && "mr-".concat(md.mr, "--md"),
        md && checkValue(md.ml) && "ml-".concat(md.ml, "--md"),
        md && checkValue(md.mt) && "mt-".concat(md.mt, "--md"),
        md && checkValue(md.mb) && "mb-".concat(md.mb, "--md"),
        md && checkValue(md.mx) && "mx-".concat(md.mx, "--md"),
        md && checkValue(md.my) && "my-".concat(md.my, "--md"),
        md && checkValue(md.p) && "p-".concat(md.p, "--md"),
        md && checkValue(md.pr) && "pr-".concat(md.pr, "--md"),
        md && checkValue(md.pl) && "pl-".concat(md.pl, "--md"),
        md && checkValue(md.pt) && "pt-".concat(md.pt, "--md"),
        md && checkValue(md.pb) && "pb-".concat(md.pb, "--md"),
        md && checkValue(md.px) && "px-".concat(md.px, "--md"),
        md && checkValue(md.py) && "py-".concat(md.py, "--md"),
        lg && checkValue(lg.m) && "m-".concat(lg.m, "--lg"),
        lg && checkValue(lg.mr) && "mr-".concat(lg.mr, "--lg"),
        lg && checkValue(lg.ml) && "ml-".concat(lg.ml, "--lg"),
        lg && checkValue(lg.mt) && "mt-".concat(lg.mt, "--lg"),
        lg && checkValue(lg.mb) && "mb-".concat(lg.mb, "--lg"),
        lg && checkValue(lg.mx) && "mx-".concat(lg.mx, "--lg"),
        lg && checkValue(lg.my) && "my-".concat(lg.my, "--lg"),
        lg && checkValue(lg.p) && "p-".concat(lg.p, "--lg"),
        lg && checkValue(lg.pr) && "pr-".concat(lg.pr, "--lg"),
        lg && checkValue(lg.pl) && "pl-".concat(lg.pl, "--lg"),
        lg && checkValue(lg.pt) && "pt-".concat(lg.pt, "--lg"),
        lg && checkValue(lg.pb) && "pb-".concat(lg.pb, "--lg"),
        lg && checkValue(lg.px) && "px-".concat(lg.px, "--lg"),
        lg && checkValue(lg.py) && "py-".concat(lg.py, "--lg")
    ];
};


/***/ }),

/***/ 23720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ colorPropTypes; },
/* harmony export */   "ET": function() { return /* binding */ sxProps; },
/* harmony export */   "Gk": function() { return /* binding */ fontSizePropTypes; },
/* harmony export */   "I1": function() { return /* binding */ sxPropTypes; },
/* harmony export */   "ZA": function() { return /* binding */ sxClassName; },
/* harmony export */   "g4": function() { return /* binding */ textAlignPropTypes; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68657);


const fontSizePropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    "xs",
    "s",
    "m",
    "l",
    "xl",
    "xxl",
    "xxxl"
]);
const colorPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    ..._utils_color__WEBPACK_IMPORTED_MODULE_0__/* .brandColors */ .D2,
    ..._utils_color__WEBPACK_IMPORTED_MODULE_0__/* .blackColors */ .qr,
    ..._utils_color__WEBPACK_IMPORTED_MODULE_0__/* .whiteColors */ .cK,
    ..._utils_color__WEBPACK_IMPORTED_MODULE_0__/* .commonColors */ .Hk
]);
const textAlignPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    "left",
    "center",
    "right"
]);
const textDecorationPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    "underline"
]);
const textTransformPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    "uppercase",
    "capitalize"
]);
const fontWeightPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
    "thin",
    "ultra-light",
    "light",
    "normal",
    "medium",
    "semi",
    "bold",
    "extra",
    "heavy"
]);
const sxProps = {
    textAlign: null,
    textTransform: null,
    textEllipsis: null,
    fontSize: null,
    fontColor: null,
    fontWeight: null,
    fontStyle: null,
    hover: {
        fontColor: null
    },
    sm: {
        textAlign: null
    },
    md: {
        textAlign: null
    },
    lg: {
        textAlign: null
    }
};
const sxPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
    textAlign: textAlignPropTypes,
    textTransform: textTransformPropTypes,
    textEllipsis: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
    fontSize: fontSizePropTypes,
    fontColor: colorPropTypes,
    textDecoration: textDecorationPropTypes,
    fontWeight: fontWeightPropTypes,
    fontStyle: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "italic"
    ]),
    hover: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        fontColor: colorPropTypes,
        textDecoration: textDecorationPropTypes
    }),
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        textAlign: textAlignPropTypes
    }),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        textAlign: textAlignPropTypes
    }),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        textAlign: textAlignPropTypes
    })
});
const sxClassName = function(param) {
    let { ...props } = param, isHeading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { textAlign , textTransform , textEllipsis , fontSize , fontColor , textDecoration , fontWeight , fontStyle , hover , sm , md , lg  } = props;
    return [
        fontSize && (isHeading ? "heading-".concat(fontSize) : "text-".concat(fontSize)),
        fontColor && "text-color-".concat(fontColor),
        hover && hover.fontColor && "text-color-".concat(hover.fontColor, "--hover"),
        fontWeight && "text-weight--".concat(fontWeight),
        fontStyle && "text-".concat(fontStyle),
        textAlign && "text-".concat(textAlign),
        textDecoration && "text-decoration--".concat(textDecoration),
        hover && hover.textDecoration && "text-decoration--".concat(hover.textDecoration, "--hover"),
        textTransform && "text-".concat(textTransform),
        textEllipsis && "text-ellipsis",
        sm && sm.textAlign && "small-text-".concat(sm.textAlign),
        md && md.textAlign && "medium-text-".concat(md.textAlign),
        lg && lg.textAlign && "large-text-".concat(lg.textAlign)
    ];
};


/***/ }),

/***/ 18981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ utilityProps; },
/* harmony export */   "b2": function() { return /* binding */ utilityClassName; },
/* harmony export */   "pQ": function() { return /* binding */ utilityPropTypes; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7820);
/* harmony import */ var _sx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23720);



const utilityProps = {
    opacity: null,
    border: null,
    display: null,
    justify: null,
    align: {
        self: null,
        items: null,
        content: null
    },
    offset: null,
    order: null,
    radius: null,
    bgColor: null,
    shadow: null,
    overflow: null,
    position: null,
    sm: {
        opacity: null,
        border: null,
        radius: null,
        display: null,
        justify: null,
        align: {
            self: null,
            items: null,
            content: null
        },
        offset: null,
        order: null
    },
    md: {
        opacity: null,
        border: null,
        radius: null,
        display: null,
        justify: null,
        align: {
            self: null,
            items: null,
            content: null
        },
        offset: null,
        order: null
    },
    lg: {
        opacity: null,
        border: null,
        radius: null,
        display: null,
        justify: null,
        align: {
            self: null,
            items: null,
            content: null
        },
        offset: null,
        order: null
    }
};
const borderRadiusTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    "50p"
]);
const borderPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
    width: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        0,
        1,
        2,
        3,
        4
    ]),
    color: _sx__WEBPACK_IMPORTED_MODULE_0__/* .colorPropTypes */ .AK
});
const positionPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
    position: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "relative",
        "absolute",
        "fixed",
        "sticky"
    ]),
    top: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]),
    bottom: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]),
    left: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]),
    right: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]),
    zIndex: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "m1",
        1,
        0
    ])
});
const adaptivePropTypes = {
    border: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([
        (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
            top: borderPropTypes,
            right: borderPropTypes,
            bottom: borderPropTypes,
            left: borderPropTypes
        }),
        borderPropTypes
    ]),
    radius: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([
        (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
            topLeft: borderRadiusTypes,
            topRight: borderRadiusTypes,
            bottomRight: borderRadiusTypes,
            bottomLeft: borderRadiusTypes
        }),
        borderRadiusTypes
    ]),
    display: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "none",
        "block",
        "inline-block",
        "flex",
        "flex-vertical"
    ]),
    justify: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "start",
        "end",
        "center",
        "between",
        "around",
        "evenly"
    ]),
    align: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        items: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
            "start",
            "end",
            "center",
            "baseline",
            "stretch"
        ]),
        self: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
            "start",
            "end",
            "center",
            "baseline",
            "stretch"
        ]),
        content: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
            "start",
            "end",
            "center",
            "between",
            "around",
            "stretch"
        ])
    }),
    offset: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    order: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    opacity: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        0,
        50,
        100
    ])
};
const utilityPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
    bgColor: _sx__WEBPACK_IMPORTED_MODULE_0__/* .colorPropTypes */ .AK,
    shadow: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_1__.bool
    ]),
    overflow: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "hidden",
        "scrollX",
        "scrollY"
    ]),
    position: positionPropTypes,
    ...adaptivePropTypes,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)(adaptivePropTypes),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)(adaptivePropTypes),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)(adaptivePropTypes)
});
const utilityClassName = (param)=>{
    let { ...props } = param;
    const { radius , border , bgColor , shadow , overflow , display , justify , align , offset , order , opacity , position , sm , md , lg  } = props;
    const borderRadiusClassNames = function(borderRadiusProps) {
        let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        const isNumber = (value)=>typeof value === "number" && value >= 0;
        const is50 = (value)=>typeof value === "string" && value === "50p";
        const mediaSize = size ? "--".concat(size) : "";
        if (borderRadiusProps && !is50(borderRadiusProps) || isNumber(borderRadiusProps) || is50(borderRadiusProps)) {
            if (is50(borderRadiusProps) || Object.keys(borderRadiusProps).length === 0) {
                // eslint-disable-next-line no-nested-ternary
                return isNumber(borderRadiusProps) ? [
                    "border-radius-".concat(borderRadiusProps, "px").concat(mediaSize)
                ] : is50(borderRadiusProps) ? [
                    "border-radius-".concat(borderRadiusProps).concat(mediaSize)
                ] : [];
            }
            const pureBorderRadiusProps = (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(borderRadiusProps);
            return Object.keys(pureBorderRadiusProps).map((key)=>{
                const value = pureBorderRadiusProps[key];
                return isNumber(value) ? "border-radius-".concat(key.split(/(?=[A-Z])/).join("-").toLowerCase(), "-").concat(value, "px").concat(mediaSize) : "";
            });
        }
        return [];
    };
    const borderClassNames = function() {
        let borderProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        const borderClassNameTemplate = function(width, color, mediaSize) {
            let key = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
            const keyValue = key ? "-".concat(key) : "";
            const widthValue = width === 0 ? "none" : "".concat(width, "px");
            const colorValue = color ? "-".concat(color) : "";
            const mediaSizeValue = mediaSize ? "--".concat(mediaSize) : "";
            return "border".concat(keyValue, "-").concat(widthValue).concat(colorValue).concat(mediaSizeValue);
        };
        if (borderProps) {
            const sideProps = borderProps.top || borderProps.right || borderProps.bottom || borderProps.left || {};
            if (Object.keys(sideProps).length === 0) {
                const { width , color =null  } = borderProps;
                return typeof width !== "undefined" && width >= 0 ? [
                    borderClassNameTemplate(width, color, size)
                ] : [];
            }
            const pureBorderProps = (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(borderProps);
            return Object.keys(pureBorderProps).map((key)=>{
                const { width , color =null  } = pureBorderProps[key];
                return typeof width !== "undefined" && width >= 0 ? borderClassNameTemplate(width, color, size, key) : "";
            });
        }
        return [];
    };
    const positionClassNames = (positionProps)=>{
        const isNumber = (value)=>typeof value === "number" && value >= 0;
        const classes = [];
        const hasProps = positionProps && Object.keys(positionProps).length > 0;
        if (hasProps && positionProps.position !== null) {
            classes.push("position-".concat(positionProps.position));
        }
        if (hasProps && isNumber(positionProps.top)) {
            classes.push("top-".concat(positionProps.top));
        }
        if (hasProps && isNumber(positionProps.right)) {
            classes.push("right-".concat(positionProps.right));
        }
        if (hasProps && isNumber(positionProps.bottom)) {
            classes.push("bottom-".concat(positionProps.bottom));
        }
        if (hasProps && isNumber(positionProps.left)) {
            classes.push("left-".concat(positionProps.left));
        }
        if (hasProps && (isNumber(positionProps.zIndex) || typeof positionProps.zIndex === "string")) {
            classes.push("z-index-".concat(positionProps.zIndex));
        }
        return classes;
    };
    const PREFIX_CLASS_BG_COLOR = "bg-color-";
    const PREFIX_CLASS_BOX_SHADOW = "box-shadow";
    const PREFIX_CLASS_DISPLAY = "display-";
    const PREFIX_CLASS_OVERFLOW = "overflow--";
    const PREFIX_CLASS_JUSTIFY = "justify-content-";
    const PREFIX_CLASS_ALIGN = "align-";
    const PREFIX_CLASS_OFFSET = "offset-";
    const PREFIX_CLASS_ORDER = "order-";
    return [
        ...borderClassNames(border),
        ...borderRadiusClassNames(radius),
        bgColor && "".concat(PREFIX_CLASS_BG_COLOR).concat(bgColor),
        shadow && PREFIX_CLASS_BOX_SHADOW,
        overflow && "".concat(PREFIX_CLASS_OVERFLOW).concat(overflow),
        display && "".concat(PREFIX_CLASS_DISPLAY).concat(display),
        justify && "".concat(PREFIX_CLASS_JUSTIFY).concat(justify),
        align && align.self && "".concat(PREFIX_CLASS_ALIGN, "self-").concat(align.self),
        align && align.items && "".concat(PREFIX_CLASS_ALIGN, "items-").concat(align.items),
        align && align.content && "".concat(PREFIX_CLASS_ALIGN, "content-").concat(align.content),
        offset && "".concat(PREFIX_CLASS_OFFSET).concat(offset),
        order && "".concat(PREFIX_CLASS_ORDER).concat(order),
        opacity && "opacity-".concat(opacity),
        ...positionClassNames(position),
        ...borderClassNames(sm && sm.border, "sm"),
        ...borderRadiusClassNames(sm && sm.radius, "sm"),
        sm && sm.display && "".concat(PREFIX_CLASS_DISPLAY).concat(sm.display, "--sm"),
        sm && sm.overflow && "".concat(PREFIX_CLASS_OVERFLOW).concat(sm.overflow, "--sm"),
        sm && sm.justify && "".concat(PREFIX_CLASS_JUSTIFY).concat(sm.justify, "--sm"),
        sm && sm.align && sm.align.self && "".concat(PREFIX_CLASS_ALIGN, "self-").concat(sm.align.self, "--sm"),
        sm && sm.align && sm.align.items && "".concat(PREFIX_CLASS_ALIGN, "items-").concat(sm.align.items, "--sm"),
        sm && sm.align && sm.align.content && "".concat(PREFIX_CLASS_ALIGN, "content-").concat(sm.align.content, "--sm"),
        sm && sm.offset && "".concat(PREFIX_CLASS_OFFSET).concat(sm.offset, "--sm"),
        sm && sm.order && "".concat(PREFIX_CLASS_ORDER).concat(sm.order, "--sm"),
        sm && sm.opacity && "opacity-".concat(sm.opacity, "--sm"),
        ...borderClassNames(md && md.border, "md"),
        ...borderRadiusClassNames(md && md.radius, "md"),
        md && md.display && "".concat(PREFIX_CLASS_DISPLAY).concat(md.display, "--md"),
        md && md.overflow && "".concat(PREFIX_CLASS_OVERFLOW).concat(md.overflow, "--md"),
        md && md.justify && "".concat(PREFIX_CLASS_JUSTIFY).concat(md.justify, "--md"),
        md && md.align && md.align.self && "".concat(PREFIX_CLASS_ALIGN, "self-").concat(md.align.self, "--md"),
        md && md.align && md.align.items && "".concat(PREFIX_CLASS_ALIGN, "items-").concat(md.align.items, "--md"),
        md && md.align && md.align.content && "".concat(PREFIX_CLASS_ALIGN, "content-").concat(md.align.content, "--md"),
        md && md.offset && "".concat(PREFIX_CLASS_OFFSET).concat(md.offset, "--md"),
        md && md.order && "".concat(PREFIX_CLASS_ORDER).concat(md.order, "--md"),
        md && md.opacity && "opacity-".concat(md.opacity, "--md"),
        ...borderClassNames(lg && lg.border, "lg"),
        ...borderRadiusClassNames(lg && lg.radius, "lg"),
        lg && lg.display && "".concat(PREFIX_CLASS_DISPLAY).concat(lg.display, "--lg"),
        lg && lg.overflow && "".concat(PREFIX_CLASS_OVERFLOW).concat(lg.overflow, "--lg"),
        lg && lg.justify && "".concat(PREFIX_CLASS_JUSTIFY).concat(lg.justify, "--lg"),
        lg && lg.align && lg.align.self && "".concat(PREFIX_CLASS_ALIGN, "self-").concat(lg.align.self, "--lg"),
        lg && lg.align && lg.align.items && "".concat(PREFIX_CLASS_ALIGN, "items-").concat(lg.align.items, "--lg"),
        lg && lg.align && lg.align.content && "".concat(PREFIX_CLASS_ALIGN, "content-").concat(lg.align.content, "--lg"),
        lg && lg.offset && "".concat(PREFIX_CLASS_OFFSET).concat(lg.offset, "--lg"),
        lg && lg.order && "".concat(PREFIX_CLASS_ORDER).concat(lg.order, "--lg"),
        lg && lg.opacity && "opacity-".concat(lg.opacity, "--lg")
    ];
};


/***/ }),

/***/ 17223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useDropDown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    initialAction: null,
    currentAction: null,
    isOpen: false,
    changeCurrentAction: ()=>{},
    open: ()=>{},
    close: ()=>{},
    toggle: ()=>{},
    settings: {},
    containerRef: ()=>{}
});
const useDropDown = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
/* harmony default export */ __webpack_exports__["Z"] = (context);


/***/ }),

/***/ 67924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ classes; }
/* harmony export */ });
/* unused harmony export cn */
/* harmony import */ var _insightfulscience_shared_utils_lib_fn_pipe__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38733);
/* harmony import */ var _transduce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70627);
/* harmony import */ var _predicates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53863);
/* eslint-disable prettier/prettier */ 


const trim = (value)=>value.trim();
const cn = (className)=>isString(className) ? trim(className) : "";
const join = function() {
    let separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return (text, str)=>text && str && "".concat(text).concat(separator).concat(str) || str || text;
};
const classes = function() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++){
        classNames[_key] = arguments[_key];
    }
    return classNames.reduce((0,_insightfulscience_shared_utils_lib_fn_pipe__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(join(" "), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX((0,_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isUnique */ .bT)()), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX(_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isNotEmpty */ .UE), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(trim), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX(_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)), "");
};


/***/ }),

/***/ 68657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ brandColors; },
/* harmony export */   "Hk": function() { return /* binding */ commonColors; },
/* harmony export */   "cK": function() { return /* binding */ whiteColors; },
/* harmony export */   "jh": function() { return /* binding */ bgColor4; },
/* harmony export */   "mE": function() { return /* binding */ bgColorWhite; },
/* harmony export */   "qr": function() { return /* binding */ blackColors; },
/* harmony export */   "vk": function() { return /* binding */ bgColorBlack2; }
/* harmony export */ });
/* unused harmony exports bgBrandGradient, bgColorNone, bgColorBlack, bgColorBlack85, bgColorBlack64, bgColorBlack60, bgColorBlack46, bgColorBlack40, bgColorBlack35, bgColorBlack20, bgColorBlack15, bgColorBlack10, bgColorBlack4, bgColorBlackCustom1, bgColorBlackCustom2, bgColorWhite80, bgColorWhite70, bgColorWhite60, bgColorWhite40, bgColorWhite35, bgColorWhite20, bgColorWhite15, bgColorWhite10, bgColorWhite4, bgColor1, bgColor114, bgColor110, bgColor105, bgColor1l, bgColor2, bgColor210, bgColor205, bgColor286, bgColor3, bgColor360, bgColor310, bgColor305, bgColor414, bgColor405, bgColor5, bgColor540, bgColor512, bgColor503, bgColor6, bgColorGreen, bgColorRed, bgColorLime, bgColorOrange, colorBlack, colorBlack85, colorBlack64, colorBlack60, colorBlack46, colorBlack40, colorBlack35, colorBlack20, colorBlack15, colorBlack10, colorBlack4, colorBlack2, colorWhite, colorWhite80, colorWhite70, colorWhite60, colorWhite40, colorWhite35, colorWhite20, colorWhite15, colorWhite10, colorWhite4, color1, color114, color110, color105, color1l, color2, color210, color205, color286, color3, color360, color310, color305, color4, color414, color405, color5, color540, color512, color503, colorGreen, colorRed, colorLime, colorOrange */
const bgTpl = (color)=>"bg-color-".concat(color);
const colorTpl = (color)=>"text-color-".concat(color);
const commonColorsSchema = {
    none: "none",
    transparent: "transparent",
    inherit: "inherit",
    red: "red",
    green: "green",
    lime: "lime",
    orange: "orange",
    "dotmatics-1": "dotmatics-1",
    "dotmatics-2": "dotmatics-2",
    "dotmatics-3": "dotmatics-3",
    "dotmatics-4": "dotmatics-4",
    "dotmatics-5": "dotmatics-5",
    "dotmatics-6": "dotmatics-6",
    "dotmatics-7": "dotmatics-7",
    "dotmatics-8": "dotmatics-8"
};
const blackColorSchema = {
    100: "black",
    85: "black--85",
    64: "black--64",
    60: "black--60",
    46: "black--46",
    40: "black--40",
    35: "black--35",
    20: "black--20",
    15: "black--15",
    10: "black--10",
    4: "black--04",
    2: "black--02",
    "custom-1": "black--custom-1",
    "custom-2": "black--custom-2"
};
const whiteColorSchema = {
    100: "white",
    80: "white--80",
    70: "white--70",
    60: "white--60",
    40: "white--40",
    35: "white--35",
    20: "white--20",
    15: "white--15",
    10: "white--10",
    4: "white--04"
};
const brandColorSchema = {
    100: "1",
    114: "1--14",
    110: "1--10",
    105: "1--05",
    "1l": "1--light",
    200: "2",
    210: "2--10",
    205: "2--05",
    240: "2--40",
    250: "2--50",
    260: "2--60",
    270: "2--70",
    "2c1": "2--custom-1",
    "2c2": "2--custom-2",
    300: "3",
    360: "3--60",
    310: "3--10",
    305: "3--05",
    400: "4",
    414: "4--14",
    405: "4--05",
    500: "5",
    540: "5--40",
    512: "5--12",
    503: "5--03",
    600: "6",
    620: "6--20",
    630: "6--30",
    650: "6--50",
    670: "6--70",
    "brand-gradient": "brand-gradient"
};
const blackColors = Object.values(blackColorSchema);
const whiteColors = Object.values(whiteColorSchema);
const brandColors = Object.values(brandColorSchema);
const commonColors = Object.values(commonColorsSchema);
const bgBrandGradient = bgTpl(brandColorSchema["brand-gradient"]);
const bgColorNone = "bg--transparent";
const bgColorBlack = bgTpl(blackColorSchema["100"]);
const bgColorBlack85 = bgTpl(blackColorSchema["85"]);
const bgColorBlack64 = bgTpl(blackColorSchema["64"]);
const bgColorBlack60 = bgTpl(blackColorSchema["60"]);
const bgColorBlack46 = bgTpl(blackColorSchema["46"]);
const bgColorBlack40 = bgTpl(blackColorSchema["40"]);
const bgColorBlack35 = bgTpl(blackColorSchema["35"]);
const bgColorBlack20 = bgTpl(blackColorSchema["20"]);
const bgColorBlack15 = bgTpl(blackColorSchema["15"]);
const bgColorBlack10 = bgTpl(blackColorSchema["10"]);
const bgColorBlack4 = bgTpl(blackColorSchema["4"]);
const bgColorBlack2 = bgTpl(blackColorSchema["2"]);
const bgColorBlackCustom1 = bgTpl(blackColorSchema["custom-1"]);
const bgColorBlackCustom2 = bgTpl(blackColorSchema["custom-2"]);
const bgColorWhite = bgTpl(whiteColorSchema["100"]);
const bgColorWhite80 = bgTpl(whiteColorSchema["80"]);
const bgColorWhite70 = bgTpl(whiteColorSchema["70"]);
const bgColorWhite60 = bgTpl(whiteColorSchema["60"]);
const bgColorWhite40 = bgTpl(whiteColorSchema["40"]);
const bgColorWhite35 = bgTpl(whiteColorSchema["35"]);
const bgColorWhite20 = bgTpl(whiteColorSchema["20"]);
const bgColorWhite15 = bgTpl(whiteColorSchema["15"]);
const bgColorWhite10 = bgTpl(whiteColorSchema["10"]);
const bgColorWhite4 = bgTpl(whiteColorSchema["4"]);
const bgColor1 = bgTpl(brandColorSchema["100"]);
const bgColor114 = bgTpl(brandColorSchema["114"]);
const bgColor110 = bgTpl(brandColorSchema["110"]);
const bgColor105 = bgTpl(brandColorSchema["105"]);
const bgColor1l = bgTpl(brandColorSchema["1l"]);
const bgColor2 = bgTpl(brandColorSchema["200"]);
const bgColor210 = bgTpl(brandColorSchema["210"]);
const bgColor205 = bgTpl(brandColorSchema["205"]);
const bgColor286 = bgTpl(brandColorSchema["286"]);
const bgColor3 = bgTpl(brandColorSchema["300"]);
const bgColor360 = bgTpl(brandColorSchema["360"]);
const bgColor310 = bgTpl(brandColorSchema["310"]);
const bgColor305 = bgTpl(brandColorSchema["305"]);
const bgColor4 = bgTpl(brandColorSchema["400"]);
const bgColor414 = bgTpl(brandColorSchema["414"]);
const bgColor405 = bgTpl(brandColorSchema["405"]);
const bgColor5 = bgTpl(brandColorSchema["500"]);
const bgColor540 = bgTpl(brandColorSchema["540"]);
const bgColor512 = bgTpl(brandColorSchema["512"]);
const bgColor503 = bgTpl(brandColorSchema["503"]);
const bgColor6 = bgTpl(brandColorSchema["600"]);
const bgColorGreen = bgTpl(commonColorsSchema.green);
const bgColorRed = bgTpl(commonColorsSchema.red);
const bgColorLime = bgTpl(commonColorsSchema.lime);
const bgColorOrange = bgTpl(commonColorsSchema.orange);
const colorBlack = colorTpl(blackColorSchema["100"]);
const colorBlack85 = colorTpl(blackColorSchema["85"]);
const colorBlack64 = colorTpl(blackColorSchema["64"]);
const colorBlack60 = colorTpl(blackColorSchema["60"]);
const colorBlack46 = colorTpl(blackColorSchema["46"]);
const colorBlack40 = colorTpl(blackColorSchema["40"]);
const colorBlack35 = colorTpl(blackColorSchema["35"]);
const colorBlack20 = colorTpl(blackColorSchema["20"]);
const colorBlack15 = colorTpl(blackColorSchema["15"]);
const colorBlack10 = colorTpl(blackColorSchema["10"]);
const colorBlack4 = colorTpl(blackColorSchema["4"]);
const colorBlack2 = colorTpl(blackColorSchema["2"]);
const colorWhite = colorTpl(whiteColorSchema["100"]);
const colorWhite80 = colorTpl(whiteColorSchema["80"]);
const colorWhite70 = colorTpl(whiteColorSchema["70"]);
const colorWhite60 = colorTpl(whiteColorSchema["60"]);
const colorWhite40 = colorTpl(whiteColorSchema["40"]);
const colorWhite35 = colorTpl(whiteColorSchema["35"]);
const colorWhite20 = colorTpl(whiteColorSchema["20"]);
const colorWhite15 = colorTpl(whiteColorSchema["15"]);
const colorWhite10 = colorTpl(whiteColorSchema["10"]);
const colorWhite4 = colorTpl(whiteColorSchema["4"]);
const color1 = colorTpl(brandColorSchema["100"]);
const color114 = colorTpl(brandColorSchema["114"]);
const color110 = colorTpl(brandColorSchema["110"]);
const color105 = colorTpl(brandColorSchema["105"]);
const color1l = colorTpl(brandColorSchema["1l"]);
const color2 = colorTpl(brandColorSchema["200"]);
const color210 = colorTpl(brandColorSchema["210"]);
const color205 = colorTpl(brandColorSchema["205"]);
const color286 = colorTpl(brandColorSchema["286"]);
const color3 = colorTpl(brandColorSchema["300"]);
const color360 = colorTpl(brandColorSchema["360"]);
const color310 = colorTpl(brandColorSchema["310"]);
const color305 = colorTpl(brandColorSchema["305"]);
const color4 = colorTpl(brandColorSchema["400"]);
const color414 = colorTpl(brandColorSchema["414"]);
const color405 = colorTpl(brandColorSchema["405"]);
const color5 = colorTpl(brandColorSchema["500"]);
const color540 = colorTpl(brandColorSchema["540"]);
const color512 = colorTpl(brandColorSchema["512"]);
const color503 = colorTpl(brandColorSchema["503"]);
const colorGreen = bgTpl(commonColorsSchema.green);
const colorRed = bgTpl(commonColorsSchema.red);
const colorLime = bgTpl(commonColorsSchema.lime);
const colorOrange = bgTpl(commonColorsSchema.orange);


/***/ }),

/***/ 46393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bd": function() { return /* binding */ callIf; },
/* harmony export */   "qC": function() { return /* binding */ compose; },
/* harmony export */   "zl": function() { return /* binding */ ifDeff; }
/* harmony export */ });
/* unused harmony exports idX, pipe, mapValues, safeCall */
const idX = (argument)=>argument;
const compose2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return f(g(...args));
    };
const compose = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(compose2) : idX;
};
const pipe2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return g(f(...args));
    };
const pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(pipe2) : idX;
};
const mapValues = (mapper)=>(obj)=>Object.assign(...Object.entries(obj).map((param)=>{
            let [key, value] = param;
            return {
                [key]: mapper(value, key, obj)
            };
        }));
const safeCall = (fn, args)=>typeof fn === "function" ? fn(...args) : undefined;
const callIf = (predicate, thenFn, elseFn)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return safeCall(predicate(...args) ? thenFn : elseFn, args);
    };
const ifDeff = (value, def)=>value !== undefined ? value : def;


/***/ }),

/***/ 36336:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    thin: "text-weight--thin",
    "ultra-light": "text-weight--ultra-light",
    light: "text-weight--light",
    normal: "text-weight--normal",
    medium: "text-weight--medium",
    semi: "text-weight--semi",
    bold: "text-weight--bold",
    extra: "text-weight--extra",
    heavy: "text-weight--heavy"
});


/***/ }),

/***/ 52418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

// eslint-disable-next-line react/forbid-prop-types
const forwardRef = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOfType)([
    prop_types__WEBPACK_IMPORTED_MODULE_0__.func,
    (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        current: prop_types__WEBPACK_IMPORTED_MODULE_0__.object
    })
]);
/* harmony default export */ __webpack_exports__["Z"] = (forwardRef);


/***/ }),

/***/ 22953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gy": function() { return /* binding */ handleWith; },
/* harmony export */   "X$": function() { return /* binding */ prevent; }
/* harmony export */ });
/* unused harmony export stop */
const prevent = (event)=>{
    return event === null || event === void 0 ? void 0 : event.preventDefault();
};
const stop = (event)=>{
    return event === null || event === void 0 ? void 0 : event.stopPropagation();
};
const handleWith = function() {
    for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
        handlers[_key] = arguments[_key];
    }
    const fnHandlers = handlers.filter((handler)=>typeof handler === "function");
    return (event)=>fnHandlers.forEach((handler)=>handler(event));
};


/***/ }),

/***/ 53863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "UE": function() { return /* binding */ isNotEmpty; },
/* harmony export */   "bT": function() { return /* binding */ isUnique; }
/* harmony export */ });
const isString = (value)=>typeof value === "string";
const isUnique = ()=>{
    const processed = new Set();
    return (value)=>{
        if (processed.has(value)) return false;
        processed.add(value);
        return true;
    };
};
const isNotEmpty = (value)=>Boolean(value);


/***/ }),

/***/ 19738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const pureFC = (Component)=>Object.assign(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(Component), Component);
/* harmony default export */ __webpack_exports__["Z"] = (pureFC);


/***/ }),

/***/ 7820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ deepMergeProps; }
/* harmony export */ });
const deepMergeProps = (obj1, obj2)=>{
    // Create a new object that combines the properties of both input objects
    const merged = {
        ...obj1,
        ...obj2
    };
    const keys = Object.keys(merged);
    // Loop through the properties of the merged object
    keys.forEach((key)=>{
        // Check if the property is an object
        if (typeof merged[key] === "object" && merged[key] !== null) {
            // If the property is an object, recursively merge the objects
            merged[key] = deepMergeProps(obj1[key] ? obj1[key] : {}, obj2[key] ? obj2[key] : {});
        }
    });
    return merged;
};
const isPlainObject = (value)=>typeof value === "object" && value !== null && [
        Object,
        undefined
    ].includes(value.constructor);
const isEmptyObject = (value)=>isPlainObject(value) && Object.getOwnPropertyNames(value).length === 0;
const filter = function(obj) {
    let processed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set();
    // Preventing circular references
    if (processed.has(obj)) throw new TypeError("Cannot process Object with circular references");
    const result = {};
    processed.add(obj);
    Object.getOwnPropertyNames(obj).forEach((name)=>{
        const value = obj[name];
        const processedValue = isPlainObject(value) ? filter(value, processed) : value;
        if (processedValue == null || isEmptyObject(processedValue)) return;
        result[name] = processedValue;
    });
    return result;
};
const removeEmptyProps = (obj)=>isPlainObject(obj) ? filter(obj) : {};
/* harmony default export */ __webpack_exports__["Z"] = (removeEmptyProps);


/***/ }),

/***/ 70627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "zh": function() { return /* binding */ transduce; }
/* harmony export */ });
/* unused harmony export push */
/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46393);
/* eslint-disable prettier/prettier */ 
const map = (mapper)=>(reducer)=>(accumulator, item, index, arr)=>reducer(accumulator, mapper(item, index, arr), index, arr);
const filter = (predicate)=>(reducer)=>(accumulator, item, index, arr)=>predicate(item, index, arr) ? reducer(accumulator, item, index, arr) : accumulator;
const push = (list, item)=>{
    list.push(item);
    return list;
};
const transduce = function(list, reducer, initialValue) {
    for(var _len = arguments.length, transducers = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        transducers[_key - 3] = arguments[_key];
    }
    return list.reduce((0,_fn__WEBPACK_IMPORTED_MODULE_0__/* .compose */ .qC)(...transducers)(reducer), initialValue);
};


/***/ }),

/***/ 93745:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.vmap = exports.summ = exports.some = exports.skipIf = exports.resolve = exports.reject = exports.promisify = exports.orderWith = exports.order = exports.mergeProps = exports.mergeAll = exports.merge = exports.mapErrors = exports.isPromise = exports.isLoaded = exports.isFunc = exports.isEmpty = exports.idX = exports.get = exports.every = exports.ensureFunc = exports.compose2 = exports.compose = exports.callWith = exports.callWhenReady = exports.call = exports.asyncAll = exports.asAsync = void 0;
/**
 * Type `Fn<Args extends any[], R>` - Generic Function
 *
 * @template {any[]} A
 * @template R
 * @typedef {(...args: A) => R} Fn
 */ /**
 * Type `Callback<Err extends Error, Res>` - Generic First-Error Callback
 *
 * @template {Error} E
 * @template R
 * @typedef {(error: E, result: R) => void} Callback
 */ /**
 * Type `CompareFn<T>` - Generic Compare Function
 *
 * @template T
 * @typedef {(item: T, list: T[], index: number) => number} CompareFn
 */ /**
 * Type `SyncType<T>` - Type extracts type packed into the Promise
 *
 * @template T
 * @typedef {T extends Promise<infer Packed> ? Packed : T} SyncType
 */ /**
 * Identiry Function
 *
 * @see https://en.wikipedia.org/wiki/Identity_function
 *
 * @type <T>(x: T) => T
 */ const idX = (x)=>x;
/**
 * Creates applicator: the function that call its argument with arguments
 * specified when applicator has been created
 *
 * @type {<A extends any[]>(...args: A) => <R>(fn: Fn<A, R>) => R}
 */ exports.idX = idX;
const call = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return (fn)=>fn(...args);
};
/**
 * Checks if argument is a Promise or not (actualy if argument is thanable)
 *
 * @type {(value: any) => value is Promise<any>}
 */ exports.call = call;
const isPromise = (value)=>value != null && typeof value.then === "function";
/**
 * Checks if argument is a Function
 *
 * @type {(value: any) => value is Function}
 */ exports.isPromise = isPromise;
const isFunc = (value)=>typeof value === "function";
/**
 * Replaces the first argument with the second one if the the first is not a Function
 *
 * @type {<T>(value: any, def: T) => Function | T}
 */ exports.isFunc = isFunc;
const ensureFunc = (value, def)=>isFunc(value) ? value : def;
/**
 * Composes two function:
 *
 * @example
 * const f = x => x + 1;
 * const g = x => x * 2;
 * const h = compose(f, g);
 * const h_ = x => f(g(x)); // the same as h
 *
 * @type {<A extends any[], R2, R1>(f1: (arg: R2) => R1, f2: (...args: A) => R2) => (...args: A) => R1}
 *
 */ exports.ensureFunc = ensureFunc;
const compose2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return f(g(...args));
    };
/**
 * Composes any number of functions.
 * 
 * @type {{
  (): <T>(x: T) => T

  <A extends any[], R>(f: (...args: A) => R): (...args: A) => R;

  <A extends any[], R2, R1>(
    f1: (arg: R2) => R1,
    f2: (...args: A) => R2
  ): (...args: A) => R1;
  
  <A extends any[], R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (...args: A) => R3
  ): (...args: A) => R1;
  
  <A extends any[], R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (...args: A) => R4
  ): (...args: A) => R1;
  
  <A extends any[], R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (...args: A) => R5
  ): (...args: A) => R1;
  
  <A extends any[], R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (...args: A) => R6
  ): (...args: A) => R1;
  
  <A extends any[], R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (...args: A) => R7
  ): (...args: A) => R1;
  
  <A extends any[], R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (...args: A) => R8
  ): (...args: A) => R1;
  
  <A extends any[], R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
    f9: (...args: A) => R9
  ): (...args: A) => R1;
  
  <A extends any[], RA, R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
    f9: (arg: RA) => R9,
		fa: (...args: A) => RA;

	<A extends any[], RB, RA, R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
		f9: (arg: RA) => R9,
		fa: (arg: RB) => RA,
    fb: (...args: A) => RB
  ): (...args: A) => R1;
  
  (...fns: Function[]): Function;
}} */ exports.compose2 = compose2;
const compose = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(compose2) : idX;
};
/**
 * Re-throws error mapped with `errorsMapper`.
 *
 * If `errorsMapper` return falsy value the original error will be re-thrown
 *
 * @type {<E1 extends Error, E2 extends Error>(errorsMapper: Fn<[E1], E2 | null | undefined>) => (e: E1) => never}
 */ exports.compose = compose;
const mapErrors = (errorsMapper)=>(err)=>{
        throw errorsMapper(err) || err;
    };
/**
 * Decorator Factory `skipIf` adds effect of replace decorated function (`fn`) call with
 * call of `altFn` if `predicate` returns truthy value.
 *
 * if `altFn` is not specified the [identity](#idX) function will be used
 *
 * @type {<A extends any[], TA>(predicate: Fn<A, boolean>, altFn?: Fn<A, TA>) => <T>(fn: Fn<A, T>) => Fn<A, T | TA>}
 */ exports.mapErrors = mapErrors;
const skipIf = function() {
    let predicate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ()=>true, altFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : idX;
    return (fn)=>function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return predicate(...args) ? altFn(...args) : fn(...args);
        };
};
/**
 * Checks if value is null or undefined
 *
 * @type {(value: any) => value is null | undefined}
 */ exports.skipIf = skipIf;
const isEmpty = (value)=>value == null;
/**
 * Mergers list of objects to the new one
 *
 * @type <T extends {}>(objects: Array<{}>) => T}
 */ exports.isEmpty = isEmpty;
const mergeAll = (props)=>Object.assign({}, ...props);
/**
 * Merges two or more objects some of those could be an async
 *
 * @type {{
 *  <T>(...props: Array<{}>): T
 *  <T>(...props: Array<{} | Promise<{}>>): Promise<T>
 * }}
 */ exports.mergeAll = mergeAll;
const mergeProps = function() {
    for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
        props[_key] = arguments[_key];
    }
    return props.some(isPromise) ? Promise.all(props).then(mergeAll) : mergeAll(props);
};
/**
 * Creates applicator: the function that call its argument with arguments
 * specified when applicator has been created
 */ exports.mergeProps = mergeProps;
const callWith = exports.callWith = call;
const promiseCallback = (resolve, reject)=>(err, result)=>err ? reject(err) : resolve(result);
/**
 * Converts error-first callbacked async function to function returns a promise
 *
 * @type {<A extends any[], E extends Error, R>(fn: (...args: A, cb: Callback<E, R>) => void) => Fn<A, Promise<R>>}
 */ const promisify = (fn)=>function promisified() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return new Promise((resolve, reject)=>fn.apply(this, args.concat(promiseCallback(resolve, reject))));
    };
/**
 * Calls error-first callbacked async funcation and returns a promise
 *
 * @type {<A extends any[], E extends Error, R>(fn: (...args: A, cb: Callback<E, R>) => void) => Promise<R>}
 */ exports.promisify = promisify;
const asAsync = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return new Promise((resolve, reject)=>fn(...args, promiseCallback(resolve, reject)));
};
/**
 * Mergers argument objects to the new one
 *
 * @type <T extends {}>(...partials: Array<{}>) => T}
 */ exports.asAsync = asAsync;
const merge = function() {
    for(var _len = arguments.length, partials = new Array(_len), _key = 0; _key < _len; _key++){
        partials[_key] = arguments[_key];
    }
    return Object.assign({}, ...partials);
};
/**
 * Sums two numbers
 *
 * Function created to be used as reducer
 *
 * @type {(a: number, b: number) => number}
 */ exports.merge = merge;
const summ = (a, b)=>a + b;
/**
 * Creates a getter for field or index.
 *
 * @type {{
 * (index: number): <C extends Array<any> | null>(container?: C) => C extends Array<infer T> ? T : C;
 * <N extends string | symbol>(field: N): <C extends { } | null>(container?: C) =>
 *   C extends null | undefined ? C :
 *   C extends { [p in N]?: infer T } ? T :
 *   undefined;
 * }}
 */ exports.summ = summ;
const get = (fieldOrIndex)=>(container)=>container && container[fieldOrIndex];
exports.get = get;
const order2 = (sort1, sort2)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return sort1(...args) || sort2(...args);
    };
/**
 * Creates a complex comparing function based on the argument comparing functions
 *
 * @type {<T>(...sorters: CompareFn<T>[]) => CompareFn<T>}
 */ const order = function() {
    for(var _len = arguments.length, sorters = new Array(_len), _key = 0; _key < _len; _key++){
        sorters[_key] = arguments[_key];
    }
    return sorters.reduce(order2);
};
/**
 * Basing on argument comparing functions creates a function that sorts an array
 *
 * Function returns a new Array.
 *
 * @template T
 * @typedef {(item: T, list: T[], index: number) => number} CompareFn
 * @type {<T>(...sorters: CompareFn<T>[]) => <S extends T>(list: S[]) => S[]}
 */ exports.order = order;
const orderWith = function() {
    for(var _len = arguments.length, sorters = new Array(_len), _key = 0; _key < _len; _key++){
        sorters[_key] = arguments[_key];
    }
    const compare = order(...sorters);
    return (list)=>list.slice().sort(compare);
};
/**
 * Builds new function from the arguments.
 * New function calls argument-functions and return promise that resolves
 * with array of results returned by correspondent argument function.
 *
 * @type {{
   (): () => Promise<[]>;

  <A extends any[], R1>(f1: Fn<A, R1>): (...args: A) => Promise<[SyncType<R1>]>;

  <A extends any[], R1, R2>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>
  ): (...args: A) => Promise<[SyncType<R1>, SyncType<R2>]>;

  <A extends any[], R1, R2, R3>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>
  ): (...args: A) => Promise<[SyncType<R1>, SyncType<R2>, SyncType<R3>]>;

  <A extends any[], R1, R2, R3, R4>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8, R9>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
    f9: Fn<A, R9>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>, SyncType<R9>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8, R9, RA>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
    f9: Fn<A, R9>,
    fa: Fn<A, RA>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>, SyncType<R9>,
    SyncType<RA>,
  ]>;

  <A extends any[], R1>(...fns: Fn<A,R>[]): (...args: A) => Promise<SyncType<R>[]>;
 }}
 */ exports.orderWith = orderWith;
const asyncAll = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Promise.all(fns.map(call(...args)));
    };
};
/**
 * Creates array predicate from item predicate.
 * New predicate returns true if and only if item predicate returns true for each array item
 *
 * @type {<T>(predicate: (item: T, list: T[], index: number) => boolean) => <S extends T>(list: S[]) => boolean}
 */ exports.asyncAll = asyncAll;
const every = (predicate)=>(list)=>list.every(predicate);
/**
 * Creates array predicate from item predicate.
 * New predicate returns true if and only if item predicate returns true for any of array items
 *
 * @type {<T>(predicate: (item: T, list: T[], index: number) => boolean) => <S extends T>(list: S[]) => boolean}
 */ exports.every = every;
const some = (predicate)=>(list)=>list.some(predicate);
/**
 * Checks if value is not null or undefined
 */ exports.some = some;
const isLoaded = (value)=>value != null;
/**
 * Maps `value` with `mapper`
 * `value` could be an array or an single value.
 *
 * If `value` is an array the vmap returns napped array
 * otherwise vamap returns single mapped value
 *
 * @type {{
 *  <T, S>(mapper: (item: T, list: T[] | null, index: number) => S): <V extends T|T[]>(value: V) => V extends T[] ? S[] : S
 * }}
 */ exports.isLoaded = isLoaded;
const vmap = (mapper)=>(value)=>Array.isArray(value) ? value.map(mapper) : mapper(value, null, 0);
/** Calls fn function when value is resolved.
 * If value is not a promise the fn will be called immediately.
 *
 * @type {<T, R>(fn: (value: T|Promise<T>) => R, value: T | Promise<T>) => V extends Promise<T> ? Promise<R> : R}
 * */ exports.vmap = vmap;
const callWhenReady = (fn, value)=>isPromise(value) ? value.then(fn) : fn(value);
exports.callWhenReady = callWhenReady;
const resolve = (value)=>Promise.resolve(value);
exports.resolve = resolve;
const reject = (error)=>Promise.reject(error);
exports.reject = reject;


/***/ }),

/***/ 38733:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = exports.ZP = void 0;
var _ = __webpack_require__(93745);
const pipe = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>fn(val), value);
};
const pipeA = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>(0, _.isPromise)(val) ? val.then(fn) : fn(val), //
    value //
    );
};
__webpack_unused_export__ = pipeA;
pipe.async = pipeA;
var _default = exports.ZP = pipe;


/***/ }),

/***/ 27639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ shared_utils_memo; },
  "nJ": function() { return /* binding */ memo1; }
});

// UNUSED EXPORTS: memo2, memo3, memoFactory, slice

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/memo/dictionary.js
const Node = ()=>({
        next: new Map()
    });
const add = (root)=>(tokens, value)=>{
        const leaf = tokens.reduce((node, token)=>{
            const subNode = node.next.get(token);
            if (subNode) return subNode;
            const newNode = Node();
            node.next.set(token, newNode);
            return newNode;
        }, root);
        leaf.value = value;
    };
const get = (root)=>(tokens)=>{
        let node = root;
        const l = tokens.length;
        for(let i = 0; node && i < l; i += 1){
            node = node.next.get(tokens[i]);
        }
        return node && node.value;
    };
const DictionaryAPI = (root)=>({
        add: add(root),
        get: get(root)
    });
const Dictionary = ()=>DictionaryAPI(Node());
/* harmony default export */ var dictionary = (Dictionary);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/memo/index.js


/**
 * Creates memoization function
 *
 * @type {(getKey: (args: any[]) => any) => <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R}
 */ const memoFactory = (getKey)=>(fn)=>{
        // Avoiding memoization on the server-side
        if (false) {}
        const cache = dictionary();
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const key = getKey(args);
            const result = cache.get(key);
            if (result) return result.value;
            const value = fn(...args);
            cache.add(key, {
                value
            });
            return value;
        };
    };
/**
 * Memoize function using all arguments as cache key
 *
 * @type {{
 *   <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R;
 *   n: (n: number) => <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R;
 * }}
 */ const memo = memoFactory(fn/* idX */.Yr);
/**
 * Creates slicer for list
 *
 * @type {(start: number, end: number) => <T>(list: T[]) => T[]}
 */ const slice = (start, end)=>(list)=>list.slice(start, end);
/**
 * Memoize function using the first one argument as cache key
 */ const memo1 = memoFactory(slice(0, 1));
/**
 * Memoize function using the first two arguments as cache key
 */ const memo2 = memoFactory(slice(0, 2));
/**
 * Memoize function using the first three arguments as cache key
 */ const memo3 = memoFactory(slice(0, 3));
/**
 * Creates memoization function that memoizes using the first `n` arguments as cache key
 */ memo.n = (n)=>memoFactory(slice(0, n));
/* harmony default export */ var shared_utils_memo = (memo);


/***/ }),

/***/ 73972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Html = (param)=>/*#__PURE__*/ {
    let { Tag ="div" , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        dangerouslySetInnerHTML: {
            __html: children
        },
        ...props
    });
};
Html.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_2__.element
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (Html);


/***/ }),

/***/ 5098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _events_handlers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28763);






function NextLink(param) {
    let { Component =_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , href , as , onClick , active , ...props } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const followLink = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>!active ? (0,_events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .handleWith */ .Gy)(onClick, _events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .prevent */ .X$, ()=>router.push(href, as)) : _events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .prevent */ .X$, [
        href,
        as,
        onClick,
        active
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        ...props,
        href: as || href,
        onClick: followLink
    });
}
NextLink.propTypes = {
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_5__.elementType
    ]),
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string.isRequired,
    as: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_5__.func,
    active: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool
};
const NextLinkPure = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextLink, {
        ...props,
        Component: "a"
    });
NextLink.Pure = NextLinkPure;
/* harmony default export */ __webpack_exports__["Z"] = (NextLink);


/***/ }),

/***/ 42202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable no-console */ 
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    data: null,
    container: null,
    run: (fn)=>{
        console.warn("Cannot run function in di-context, due it is not provided");
        console.log({
            fn: fn && (fn.name || fn.toString())
        });
    }
}));


/***/ }),

/***/ 87348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IO": function() { return /* binding */ useExec; },
/* harmony export */   "Sr": function() { return /* binding */ useRun; },
/* harmony export */   "Vi": function() { return /* binding */ usePageData; }
/* harmony export */ });
/* unused harmony export useData */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10455);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42202);



let deprecationWarning = ()=>{
    // eslint-disable-next-line no-console
    console.warn('useData hook is deprecated. Use "usePageData instead."');
    deprecationWarning = ()=>{};
};
const usePageData = function() {
    let selector = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_2__/* .idX */ .Yr;
    return selector(react__WEBPACK_IMPORTED_MODULE_0__.useContext(_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).data);
};
const useData = (selector)=>{
    deprecationWarning();
    return usePageData(selector);
};
const useRun = (action)=>{
    const { run  } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return run(action(...args));
    }, [
        action,
        run
    ]);
};
const useExec = (thunk, deps)=>{
    const { run  } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>run(thunk), deps);
};


/***/ }),

/***/ 28763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FE": function() { return /* binding */ composeRefs; },
/* harmony export */   "Gy": function() { return /* binding */ handleWith; },
/* harmony export */   "X$": function() { return /* binding */ prevent; },
/* harmony export */   "aV": function() { return /* binding */ asyncHandleWith; },
/* harmony export */   "k$": function() { return /* binding */ setRef; }
/* harmony export */ });
/* unused harmony export stop */
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10455);
/* harmony import */ var _insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);


const handleWith = function() {
    for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
        handlers[_key] = arguments[_key];
    }
    const fnHandlers = handlers.filter(_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl);
    return (event)=>fnHandlers.forEach((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .call */ .RE)(event));
};
handleWith.m = (0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(handleWith);
const asyncHandleWith = function() {
    let delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    return function() {
        for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
            handlers[_key] = arguments[_key];
        }
        const fnHandlers = handlers.filter(_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl);
        return (event)=>setTimeout(()=>fnHandlers.forEach((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .call */ .RE)(event)), delay);
    };
};
asyncHandleWith.m = (delay)=>(0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(asyncHandleWith(delay));
const prevent = (event)=>{
    event.preventDefault();
};
const stop = (event)=>{
    event.stopPropagation();
};
const setRef = (ref, value)=>{
    if (ref == null) return;
    if ((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl)(ref)) {
        ref(value);
        return;
    }
    ref.current = value; // eslint-disable-line no-param-reassign
};
const assignRef = (element)=>(ref)=>setRef(ref, element);
const composeRefs = function() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (element)=>refs.forEach(assignRef(element));
};
composeRefs.m = (0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(composeRefs);


/***/ }),

/***/ 91491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DiPageHoC_DiPageHoC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/displayName.js
var displayName = __webpack_require__(75511);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/context.js
var context = __webpack_require__(18018);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hoc-merge-props.js

const merge = (propName)=>(props, value)=>({
            ...props,
            [propName]: {
                value,
                toJSON: ()=>null
            }
        });
const extract = (propName)=>{
    return (props)=>{
        var ref;
        const value = (ref = props[propName]) === null || ref === void 0 ? void 0 : ref.value;
        const propsCopy = {
            ...props
        };
        delete propsCopy[propName];
        return [
            value,
            propsCopy
        ];
    };
};
const getPropsAndMerge = (mergeFn)=>function(getProps, value) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        const props = (0,fn/* isFunc */.Wl)(getProps) ? getProps(...args) : null;
        return (0,fn/* isPromise */.tI)(props) ? props.then((resolved)=>mergeFn(resolved, value)) : mergeFn(props, value);
    };
const NotSerializableProp = (propName)=>{
    const ownMerge = merge(propName);
    return {
        merge: ownMerge,
        extract: extract(propName),
        getPropsAndMerge: getPropsAndMerge(ownMerge)
    };
};
/* harmony default export */ var hoc_merge_props = (NotSerializableProp);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/DiPageHoC.js






const { merge: DiPageHoC_merge , extract: DiPageHoC_extract  } = hoc_merge_props("container");
const useIsomorphicEffect =  false ? 0 : react.useLayoutEffect;
const DiPageHoC = (createContainer)=>(Page)=>{
        const DiPage = (pageProps)=>{
            const [containerFromProps, data] = DiPageHoC_extract(pageProps);
            const container = (0,react.useMemo)(()=>containerFromProps !== null && containerFromProps !== void 0 ? containerFromProps : createContainer(null), []);
            const [state, setState] = (0,react.useState)(data);
            const stateRef = (0,react.useRef)();
            stateRef.current = state;
            const updateState = (0,react.useCallback)((statePatch)=>{
                const newState = typeof statePatch === "function" ? statePatch(stateRef.current) : statePatch;
                stateRef.current = newState;
                setState(newState);
            }, [
                setState
            ]);
            useIsomorphicEffect(()=>{
                if (state === data) return;
                updateState(data);
            }, [
                pageProps
            ]);
            const run = react.useCallback((fn)=>fn(container, stateRef.current, run, updateState), [
                container
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
                value: {
                    run,
                    data: state,
                    container,
                    setState: updateState
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    ...data
                })
            });
        };
        Object.assign(DiPage, Page); // copying all static props
        DiPage.displayName = (0,displayName/* default */.Z)("withDiContext", Page);
        DiPage.getInitialProps = (context)=>{
            const container = createContainer(context);
            const runGetInitProps = (fn)=>fn(context, container, runGetInitProps);
            const props = typeof Page.getInitialProps === "function" ? runGetInitProps(Page.getInitialProps) : null;
            return (0,fn/* isPromise */.tI)(props) ? props.then((resolved)=>DiPageHoC_merge(resolved, container)) : DiPageHoC_merge(props, container);
        };
        return DiPage;
    };
/* harmony default export */ var DiPageHoC_DiPageHoC = (DiPageHoC);


/***/ }),

/***/ 18018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _di_context_context__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _di_context_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42202);



/***/ }),

/***/ 44611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IO": function() { return /* reexport */ hooks/* useExec */.IO; },
  "Vi": function() { return /* reexport */ hooks/* usePageData */.Vi; },
  "Sr": function() { return /* reexport */ hooks/* useRun */.Sr; },
  "Su": function() { return /* reexport */ useServices; }
});

// UNUSED EXPORTS: default, useData

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/context.js
var context = __webpack_require__(18018);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/di-context/hooks.js
var hooks = __webpack_require__(87348);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/hooks.js



const useServices = function() {
    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
        names[_key] = arguments[_key];
    }
    const { container  } = react.useContext(context/* default */.Z);
    return react.useMemo(()=>names.map((name)=>container[name]), names);
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/DiPageHoC.js + 1 modules
var DiPageHoC = __webpack_require__(91491);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/index.js




/***/ })

}]);